const btnModalPayu = $("#btnModalPayu")
const closeModalPayu = $("#close_modal_payu")
const formPayu = $('form#payu-form')
const btnContinue = $('#btnContinue')
const btnSubmitForm = $('#btnSubmitFormPayu')
const billingCountry = $('#billingCountry')
const province = $('#province')
const province_text = $('#province_text')
const countriesOrdered =  [
    [
        "Afghanistan",
        {
            "address_format": {
                "edit": 0
            },
            "code": "AF",
            "flag_path": "/assets/flags/af-629a0ca75359dbaac4630de374041bbe17bb684adbc5765bb74633111bf42ab6.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Aland Islands",
        {
            "address_format": {
                "edit": 1
            },
            "code": "AX",
            "flag_path": "/assets/flags/ax-b25b34f1aef122416fd1878d6eea001f115ff60b8eab3266ad96a76869529d56.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Albania",
        {
            "address_format": {
                "edit": 0
            },
            "code": "AL",
            "flag_path": "/assets/flags/al-e223abdb13c475b827e74fa29a44a98e26675402fb46513eadc875faca72305e.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Algeria",
        {
            "address_format": {
                "edit": 1
            },
            "code": "DZ",
            "flag_path": "/assets/flags/dz-35fe9924da28ee1efefce8c62f18d88fb890c1fbb247040d92291eb89bcd83d7.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Andorra",
        {
            "address_format": {
                "edit": 1
            },
            "code": "AD",
            "flag_path": "/assets/flags/ad-14d0d11aef616c81ff2b0bd208a7e2317d545c13e5dd7abe6af60cbf4dddedba.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Angola",
        {
            "address_format": {
                "edit": 2
            },
            "code": "AO",
            "flag_path": "/assets/flags/ao-c1b3fb116d39434b4426bae3b90c2162ff5aa257a585eaf8535ae8412776dc33.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Anguilla",
        {
            "address_format": {
                "edit": 2
            },
            "code": "AI",
            "flag_path": "/assets/flags/ai-51cea12f14fec3a8a7b52d035b7444a3df4a1d82ded34db382e6660078790c91.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Antigua And Barbuda",
        {
            "address_format": {
                "edit": 2
            },
            "code": "AG",
            "flag_path": "/assets/flags/ag-a6c867b8ad588a2f489c4e113dbc450d0d363504c8aaf96ac0ab7faba20dc72e.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Argentina",
        {
            "address_format": {
                "edit": 3
            },
            "code": "AR",
            "flag_path": "/assets/flags/ar-8c78ed26dbf91df5caacf7cfc90e60f53c1100c56f4f88aa2dc55dfc4b492c62.svg",
            "labels": {
                "province": "Provincia"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Buenos Aires": {
                    "label": "Buenos Aires (provincia)",
                    "code": "B"
                },
                "Catamarca": {
                    "code": "K"
                },
                "Chaco": {
                    "code": "H"
                },
                "Chubut": {
                    "code": "U"
                },
                "Ciudad Autónoma de Buenos Aires": {
                    "alternate_names": [
                        "Ciudad Autonoma de Buenos Aires"
                    ],
                    "code": "C"
                },
                "Córdoba": {
                    "alternate_names": [
                        "Cordoba"
                    ],
                    "code": "X"
                },
                "Corrientes": {
                    "code": "W"
                },
                "Entre Ríos": {
                    "alternate_names": [
                        "Entre Rios"
                    ],
                    "code": "E"
                },
                "Formosa": {
                    "code": "P"
                },
                "Jujuy": {
                    "code": "Y"
                },
                "La Pampa": {
                    "code": "L"
                },
                "La Rioja": {
                    "code": "F"
                },
                "Mendoza": {
                    "code": "M"
                },
                "Misiones": {
                    "code": "N"
                },
                "Neuquén": {
                    "alternate_names": [
                        "Neuquen"
                    ],
                    "code": "Q"
                },
                "Río Negro": {
                    "alternate_names": [
                        "Rio Negro"
                    ],
                    "code": "R"
                },
                "Salta": {
                    "code": "A"
                },
                "San Juan": {
                    "code": "J"
                },
                "San Luis": {
                    "code": "D"
                },
                "Santa Cruz": {
                    "code": "Z"
                },
                "Santa Fe": {
                    "code": "S"
                },
                "Santiago Del Estero": {
                    "label": "Santiago del Estero",
                    "code": "G"
                },
                "Tierra Del Fuego": {
                    "label": "Tierra del Fuego",
                    "code": "V"
                },
                "Tucumán": {
                    "alternate_names": [
                        "Tucuman"
                    ],
                    "code": "T"
                }
            }
        }
    ],
    [
        "Armenia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "AM",
            "flag_path": "/assets/flags/am-1eb2190d967efac59bb4f18f699b465f76dc3128593011e59243450cd593f846.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Aruba",
        {
            "address_format": {
                "edit": 2
            },
            "code": "AW",
            "flag_path": "/assets/flags/aw-7cfcf6fe4e864f96c85c801b08166cd6d95407339dbee01c89792b9714ac96ee.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Ascension Island",
        {
            "address_format": {
                "edit": 2
            },
            "code": "AC",
            "flag_path": "/assets/flags/ac-a56a872340f515db36b0ae3d9a9d16c9b39bea101e09a67ef6cba9169d8dce7f.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Australia",
        {
            "address_format": {
                "edit": 4
            },
            "code": "AU",
            "flag_path": "/assets/flags/au-777847adcc7320aae16afbaa3c8b45394f616ee81bfd3344e6c62ae4d60cfe09.svg",
            "labels": {
                "city": "Suburbio",
                "province": "Estado/territorio"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "South Australia": {
                    "label": "Australia Meridional",
                    "code": "SA"
                },
                "Western Australia": {
                    "label": "Australia Occidental",
                    "code": "WA"
                },
                "New South Wales": {
                    "label": "Nueva Gales del Sur",
                    "code": "NSW"
                },
                "Queensland": {
                    "code": "QLD"
                },
                "Tasmania": {
                    "code": "TAS"
                },
                "Australian Capital Territory": {
                    "label": "Territorio de la Capital Australiana",
                    "code": "ACT"
                },
                "Northern Territory": {
                    "label": "Territorio del Norte",
                    "code": "NT"
                },
                "Victoria": {
                    "code": "VIC"
                }
            }
        }
    ],
    [
        "Austria",
        {
            "address_format": {
                "edit": 1
            },
            "code": "AT",
            "flag_path": "/assets/flags/at-36ccf38f5cb436e5389f22bed41eb3ae0bf450cf7e556a2deb60b2fa0de6df4b.svg",
            "labels": {
                "address1": "Calle y número de casa",
                "address2": "Dirección adicional (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Azerbaijan",
        {
            "address_format": {
                "edit": 1
            },
            "code": "AZ",
            "flag_path": "/assets/flags/az-9077c269bd34c3b7259f423070199ae773784020d685fe8b0bd33866e9490bd9.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Bahamas",
        {
            "address_format": {
                "edit": 2
            },
            "code": "BS",
            "flag_path": "/assets/flags/bs-0a5947e236153988b03090541c24beec047a0f38caad2efde263f55ae5743122.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Bahrain",
        {
            "address_format": {
                "edit": 0
            },
            "code": "BH",
            "flag_path": "/assets/flags/bh-5de90f44467b3f74b9047ded41801dd80522663776d7edb4b0591025e2d1de14.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Bangladesh",
        {
            "address_format": {
                "edit": 0
            },
            "code": "BD",
            "flag_path": "/assets/flags/bd-0bcebecf72e484402234e3425a9c99dc77872d4f67406e496aee216f5216434e.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Barbados",
        {
            "address_format": {
                "edit": 0
            },
            "code": "BB",
            "flag_path": "/assets/flags/bb-65a5474c26c535eee6c651f3574a24d687987db7501ec28acda89229e43a70af.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Belarus",
        {
            "address_format": {
                "edit": 1
            },
            "code": "BY",
            "flag_path": "/assets/flags/by-681f045706d25003a1d3d976f20bc38151741926347add682871a6884ef65567.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Belgium",
        {
            "address_format": {
                "edit": 1
            },
            "code": "BE",
            "flag_path": "/assets/flags/be-605b4f8371212de6c6cd8226ebacb9c6fb529563b1250c4ad1665bd6ddfa19b2.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Belize",
        {
            "address_format": {
                "edit": 2
            },
            "code": "BZ",
            "flag_path": "/assets/flags/bz-be7ca63b723177dd32062151fa52062d8293a506b37d8779d0b4782839cb88e1.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Benin",
        {
            "address_format": {
                "edit": 2
            },
            "code": "BJ",
            "flag_path": "/assets/flags/bj-03e7fd78282d719338630eaf2301fa9c9dbcbf57a9639a20e8fbb43353409569.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Bermuda",
        {
            "address_format": {
                "edit": 0
            },
            "code": "BM",
            "flag_path": "/assets/flags/bm-ab1143dc23d4811181abe2bd72d20a2e2d21ecf8b4b80ffd724262c0d20fb5dc.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Bhutan",
        {
            "address_format": {
                "edit": 0
            },
            "code": "BT",
            "flag_path": "/assets/flags/bt-1f7a96f771b6cc7ca6854fb0c2718bf39998e0eb6f12c056dca00f2219c48ad1.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Bolivia",
        {
            "address_format": {
                "edit": 2
            },
            "code": "BO",
            "flag_path": "/assets/flags/bo-203940706b5c1cbf8dc221b5fe531d084384e12d26297071f2c3e159d397993c.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Bosnia And Herzegovina",
        {
            "address_format": {
                "edit": 1
            },
            "code": "BA",
            "flag_path": "/assets/flags/ba-64caa4a8201ac0c7799134ab54b4d3066a4d350fc0a2235be2332a84f37705e1.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Botswana",
        {
            "address_format": {
                "edit": 2
            },
            "code": "BW",
            "flag_path": "/assets/flags/bw-383f863653ddeb74bbf374bbdc7b1f0d67de20a4565624e8d6eb2bd114a65fcf.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Bouvet Island",
        {
            "address_format": {
                "edit": 0
            },
            "code": "BV",
            "flag_path": "/assets/flags/bv-342d1ac081c73a4abb571bf5b9886093ba8ac3d1d81ac834eac7f945c23afd85.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Brazil",
        {
            "address_format": {
                "edit": 5
            },
            "code": "BR",
            "flag_path": "/assets/flags/br-3580d38b09a3be988def24454370a210ec41a51d71c7994211e6931a3501106e.svg",
            "labels": {
                "address1": "Calle y número de casa",
                "province": "Estado"
            },
            "autocompletion_field": "zip",
            "provinces": {
                "Alagoas": {
                    "code": "AL"
                },
                "Amapá": {
                    "alternate_names": [
                        "Amapa"
                    ],
                    "code": "AP"
                },
                "Ceará": {
                    "alternate_names": [
                        "Ceara"
                    ],
                    "code": "CE"
                },
                "Distrito Federal": {
                    "code": "DF"
                },
                "Acre": {
                    "label": "Estado de Acre",
                    "code": "AC"
                },
                "Amazonas": {
                    "label": "Estado de Amazonas",
                    "code": "AM"
                },
                "Bahia": {
                    "label": "Estado de Bahía",
                    "code": "BA"
                },
                "Espírito Santo": {
                    "label": "Estado de Espírito Santo",
                    "alternate_names": [
                        "Espirito Santo"
                    ],
                    "code": "ES"
                },
                "Goiás": {
                    "label": "Estado de Goiás",
                    "alternate_names": [
                        "Goias"
                    ],
                    "code": "GO"
                },
                "Minas Gerais": {
                    "label": "Estado de Minas Gerais",
                    "code": "MG"
                },
                "Rio de Janeiro": {
                    "label": "Estado de Río de Janeiro",
                    "code": "RJ"
                },
                "Maranhão": {
                    "alternate_names": [
                        "Maranhao"
                    ],
                    "code": "MA"
                },
                "Mato Grosso": {
                    "code": "MT"
                },
                "Mato Grosso do Sul": {
                    "label": "Mato Grosso del Sur",
                    "code": "MS"
                },
                "Pará": {
                    "alternate_names": [
                        "Para"
                    ],
                    "code": "PA"
                },
                "Paraíba": {
                    "alternate_names": [
                        "Paraiba"
                    ],
                    "code": "PB"
                },
                "Paraná": {
                    "alternate_names": [
                        "Parana"
                    ],
                    "code": "PR"
                },
                "Pernambuco": {
                    "code": "PE"
                },
                "Piauí": {
                    "alternate_names": [
                        "Piaui"
                    ],
                    "code": "PI"
                },
                "Rio Grande do Norte": {
                    "label": "Río Grande del Norte",
                    "code": "RN"
                },
                "Rio Grande do Sul": {
                    "label": "Río Grande del Sur",
                    "code": "RS"
                },
                "Rondônia": {
                    "label": "Rondonia",
                    "alternate_names": [
                        "Rondonia"
                    ],
                    "code": "RO"
                },
                "Roraima": {
                    "code": "RR"
                },
                "Santa Catarina": {
                    "code": "SC"
                },
                "São Paulo": {
                    "alternate_names": [
                        "Sao Paulo"
                    ],
                    "code": "SP"
                },
                "Sergipe": {
                    "code": "SE"
                },
                "Tocantins": {
                    "code": "TO"
                }
            }
        }
    ],
    [
        "British Indian Ocean Territory",
        {
            "address_format": {
                "edit": 0
            },
            "code": "IO",
            "flag_path": "/assets/flags/io-2792dc4447135370299d3b59f9e07c46c918fbf65ac78c1c8468f1dcb8588e3f.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Brunei",
        {
            "address_format": {
                "edit": 0
            },
            "code": "BN",
            "flag_path": "/assets/flags/bn-8acdbd12ce2970ea88a8d60baec38ab331326f4e859787d37ec6c6fa77239918.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Bulgaria",
        {
            "address_format": {
                "edit": 1
            },
            "code": "BG",
            "flag_path": "/assets/flags/bg-8f02be9c856dab65b5960e1e91f41505011351221bf10a0ad74595b75291d6e4.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Burkina Faso",
        {
            "address_format": {
                "edit": 1
            },
            "code": "BF",
            "flag_path": "/assets/flags/bf-b03a5c66c4f3785e84dc08cc492e8ab8919817432a5f5144ffdb8b4a2121fea6.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Burundi",
        {
            "address_format": {
                "edit": 2
            },
            "code": "BI",
            "flag_path": "/assets/flags/bi-585459b7ed7b55b7e5c04421b659b2d2a69cbf563308fd4d5ab8b4060b28a819.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Cambodia",
        {
            "address_format": {
                "edit": 0
            },
            "code": "KH",
            "flag_path": "/assets/flags/kh-856717da323cc34f572424095b890f1c796455dfbb7ae82dc4afcf407d376c0a.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Canada",
        {
            "address_format": {
                "edit": 4
            },
            "code": "CA",
            "flag_path": "/assets/flags/ca-36067838ee197c99c873d4e616718621c3ded8088e6035e9397994401b814ff2.svg",
            "labels": {
                "province": "Provincia"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Alberta": {
                    "code": "AB"
                },
                "British Columbia": {
                    "label": "Columbia Británica",
                    "code": "BC"
                },
                "Prince Edward Island": {
                    "label": "Isla del Príncipe Eduardo",
                    "code": "PE"
                },
                "Manitoba": {
                    "code": "MB"
                },
                "Nova Scotia": {
                    "label": "Nueva Escocia",
                    "code": "NS"
                },
                "New Brunswick": {
                    "label": "Nuevo Brunswick",
                    "code": "NB"
                },
                "Nunavut": {
                    "code": "NU"
                },
                "Ontario": {
                    "code": "ON"
                },
                "Quebec": {
                    "alternate_names": [
                        "Québec"
                    ],
                    "code": "QC"
                },
                "Saskatchewan": {
                    "code": "SK"
                },
                "Newfoundland and Labrador": {
                    "label": "Terranova y Labrador",
                    "alternate_names": [
                        "Newfoundland"
                    ],
                    "code": "NL"
                },
                "Northwest Territories": {
                    "label": "Territorios del Noroeste",
                    "code": "NT"
                },
                "Yukon": {
                    "label": "Yukón",
                    "code": "YT"
                }
            }
        }
    ],
    [
        "Cape Verde",
        {
            "address_format": {
                "edit": 1
            },
            "code": "CV",
            "flag_path": "/assets/flags/cv-93ddd786628367e1a22ad7f53567414683baddd2be693f122816ff3fd4fae350.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Caribbean Netherlands",
        {
            "address_format": {
                "edit": 2
            },
            "code": "BQ",
            "flag_path": "/assets/flags/bq-2676c5cacafd969d7d6e4acd949bbd94a0f93d22acea24da776177266b5cd606.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Cayman Islands",
        {
            "address_format": {
                "edit": 0
            },
            "code": "KY",
            "flag_path": "/assets/flags/ky-bbb31f7622a5b77ada3574b0fc249bc9669d4ab3ff24bdde9c2ecf59ff05ed1c.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Central African Republic",
        {
            "address_format": {
                "edit": 2
            },
            "code": "CF",
            "flag_path": "/assets/flags/cf-3c2768dbac8944da1bd2eab69b24e6af888d2826eb0a1e6831558cfd10b8447a.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Chad",
        {
            "address_format": {
                "edit": 2
            },
            "code": "TD",
            "flag_path": "/assets/flags/td-46d9a786225c476c021be32564d43497ec48d654694379969ac86d4aec8cf8a0.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Chile",
        {
            "address_format": {
                "edit": 6
            },
            "code": "CL",
            "flag_path": "/assets/flags/cl-f395cb9fed01b8b5a872b0b543e2f348665d966d9a6c183764f6bf0a9b4f494e.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Arica and Parinacota": {
                    "label": "Arica y Parinacota",
                    "alternate_names": [
                        "Arica y Parinacota",
                        "Región de Arica y Parinacota",
                        "Region de Arica y Parinacota"
                    ],
                    "code": "AP"
                },
                "Tarapacá": {
                    "alternate_names": [
                        "Tarapaca",
                        "Región de Tarapacá",
                        "Region de Tarapaca"
                    ],
                    "code": "TA"
                },
                "Antofagasta": {
                    "alternate_names": [
                        "Región de Antofagasta",
                        "Region de Antofagasta"
                    ],
                    "code": "AN"
                },
                "Atacama": {
                    "alternate_names": [
                        "Región de Atacama",
                        "Region de Atacama"
                    ],
                    "code": "AT"
                },
                "Coquimbo": {
                    "alternate_names": [
                        "Región de Coquimbo",
                        "Region de Coquimbo"
                    ],
                    "code": "CO"
                },
                "Valparaíso": {
                    "alternate_names": [
                        "Valparaiso",
                        "Región de Valparaíso",
                        "Region de Valparaiso"
                    ],
                    "code": "VS"
                },
                "Santiago": {
                    "alternate_names": [
                        "Región Metropolitana",
                        "Region Metropolitana",
                        "Región Metropolitana de Santiago",
                        "Region Metropolitana de Santiago"
                    ],
                    "code": "RM"
                },
                "O'Higgins": {
                    "label": "O’Higgins",
                    "alternate_names": [
                        "Región del Libertador General Bernardo O'Higgins",
                        "Region del Libertador General Bernardo O'Higgins"
                    ],
                    "code": "LI"
                },
                "Maule": {
                    "alternate_names": [
                        "Región del Maule",
                        "Region del Maule"
                    ],
                    "code": "ML"
                },
                "Ñuble": {
                    "alternate_names": [
                        "Nuble",
                        "Región de Ñuble",
                        "Region de Nuble"
                    ],
                    "code": "NB"
                },
                "Biobío": {
                    "alternate_names": [
                        "Biobio",
                        "Región del Biobío",
                        "Region del Biobio"
                    ],
                    "code": "BI"
                },
                "Araucanía": {
                    "alternate_names": [
                        "Araucania",
                        "Región de La Araucanía",
                        "Region de La Araucania"
                    ],
                    "code": "AR"
                },
                "Los Ríos": {
                    "alternate_names": [
                        "Los Rios",
                        "Región de Los Ríos",
                        "Region de Los Rios"
                    ],
                    "code": "LR"
                },
                "Los Lagos": {
                    "alternate_names": [
                        "Región de Los Lagos",
                        "Region de Los Lagos"
                    ],
                    "code": "LL"
                },
                "Aysén": {
                    "alternate_names": [
                        "Aysen",
                        "Región Aysén del General Carlos Ibáñez del Campo",
                        "Region Aysen del General Carlos Ibanez del Campo"
                    ],
                    "code": "AI"
                },
                "Magallanes": {
                    "alternate_names": [
                        "Magallanes y la Antártica Chilena",
                        "Magallanes y la Antartica Chilena",
                        "Magallanes and Chilean Antarctica",
                        "Región de Magallanes y de la Antártica Chilena",
                        "Region de Magallanes y de la Antartica Chilena"
                    ],
                    "code": "MA"
                }
            }
        }
    ],
    [
        "China",
        {
            "address_format": {
                "edit": 4
            },
            "code": "CN",
            "flag_path": "/assets/flags/cn-bbbb8832f2be4d63655bbe19ce98099c5339a9d93a301abcadb7084a4ee49002.svg",
            "labels": {
                "address1": "Dirección completa",
                "province": "Provincia"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Anhui": {
                    "alternate_names": [
                        "安徽"
                    ],
                    "code": "AH"
                },
                "Chongqing": {
                    "alternate_names": [
                        "重庆"
                    ],
                    "code": "CQ"
                },
                "Fujian": {
                    "alternate_names": [
                        "福建"
                    ],
                    "code": "FJ"
                },
                "Gansu": {
                    "alternate_names": [
                        "甘肃"
                    ],
                    "code": "GS"
                },
                "Guangxi": {
                    "alternate_names": [
                        "广西"
                    ],
                    "code": "GX"
                },
                "Guizhou": {
                    "alternate_names": [
                        "贵州"
                    ],
                    "code": "GZ"
                },
                "Hainan": {
                    "alternate_names": [
                        "海南"
                    ],
                    "code": "HI"
                },
                "Hebei": {
                    "alternate_names": [
                        "河北"
                    ],
                    "code": "HE"
                },
                "Heilongjiang": {
                    "alternate_names": [
                        "黑龙江"
                    ],
                    "code": "HL"
                },
                "Henan": {
                    "alternate_names": [
                        "河南"
                    ],
                    "code": "HA"
                },
                "Hubei": {
                    "alternate_names": [
                        "湖北"
                    ],
                    "code": "HB"
                },
                "Hunan": {
                    "alternate_names": [
                        "湖南"
                    ],
                    "code": "HN"
                },
                "Jiangsu": {
                    "alternate_names": [
                        "江苏"
                    ],
                    "code": "JS"
                },
                "Jiangxi": {
                    "alternate_names": [
                        "江西"
                    ],
                    "code": "JX"
                },
                "Jilin": {
                    "alternate_names": [
                        "吉林"
                    ],
                    "code": "JL"
                },
                "Liaoning": {
                    "alternate_names": [
                        "辽宁"
                    ],
                    "code": "LN"
                },
                "Inner Mongolia": {
                    "label": "Mongolia Interior",
                    "alternate_names": [
                        "内蒙古",
                        "Nei Mongol"
                    ],
                    "code": "NM"
                },
                "Ningxia": {
                    "alternate_names": [
                        "宁夏"
                    ],
                    "code": "NX"
                },
                "Beijing": {
                    "label": "Pekín",
                    "alternate_names": [
                        "北京"
                    ],
                    "code": "BJ"
                },
                "Guangdong": {
                    "label": "Provincia de Cantón",
                    "alternate_names": [
                        "广东"
                    ],
                    "code": "GD"
                },
                "Qinghai": {
                    "alternate_names": [
                        "青海"
                    ],
                    "code": "QH"
                },
                "Shaanxi": {
                    "alternate_names": [
                        "陕西"
                    ],
                    "code": "SN"
                },
                "Shandong": {
                    "alternate_names": [
                        "山东"
                    ],
                    "code": "SD"
                },
                "Shanghai": {
                    "label": "Shanghái",
                    "alternate_names": [
                        "上海"
                    ],
                    "code": "SH"
                },
                "Shanxi": {
                    "alternate_names": [
                        "山西"
                    ],
                    "code": "SX"
                },
                "Sichuan": {
                    "alternate_names": [
                        "四川"
                    ],
                    "code": "SC"
                },
                "Xinjiang": {
                    "label": "Sinkiang",
                    "alternate_names": [
                        "新疆"
                    ],
                    "code": "XJ"
                },
                "Tianjin": {
                    "alternate_names": [
                        "天津"
                    ],
                    "code": "TJ"
                },
                "Xizang": {
                    "label": "Tíbet",
                    "alternate_names": [
                        "西藏",
                        "Tibet"
                    ],
                    "code": "YZ"
                },
                "Yunnan": {
                    "alternate_names": [
                        "云南"
                    ],
                    "code": "YN"
                },
                "Zhejiang": {
                    "alternate_names": [
                        "浙江"
                    ],
                    "code": "ZJ"
                }
            }
        }
    ],
    [
        "Christmas Island",
        {
            "address_format": {
                "edit": 2
            },
            "code": "CX",
            "flag_path": "/assets/flags/cx-78fffe19c922f20d500c43f8448479dc2e9f1942c6e3d5b965f2fd69f244d1eb.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Cocos (Keeling) Islands",
        {
            "address_format": {
                "edit": 2
            },
            "code": "CC",
            "flag_path": "/assets/flags/cc-2a877042579b9f41b02574b8c954aa543fbbab036af6eed004abcb3b9b103204.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Colombia",
        {
            "address_format": {
                "edit": 4
            },
            "code": "CO",
            "flag_path": "/assets/flags/co-833cebf72c84df1ad872a74e100de30e2997808ac14752c2f7cd84ecdadca987.svg",
            "labels": {
                "province": "Provincia"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Bogotá, D.C.": {
                    "label": "Bogotá",
                    "alternate_names": [
                        "Bogota, D.C.",
                        "Bogotá",
                        "Bogota",
                        "Capital District",
                        "Distrito Capital de Bogotá",
                        "Distrito Capital de Bogota"
                    ],
                    "code": "DC"
                },
                "Amazonas": {
                    "code": "AMA"
                },
                "Antioquia": {
                    "code": "ANT"
                },
                "Arauca": {
                    "code": "ARA"
                },
                "San Andrés, Providencia y Santa Catalina": {
                    "label": "Archipiélago de San Andrés, Providencia y Santa Catalina",
                    "alternate_names": [
                        "San Andres, Providencia y Santa Catalina",
                        "San Andrés y Providencia",
                        "San Andres y Providencia"
                    ],
                    "code": "SAP"
                },
                "Atlántico": {
                    "alternate_names": [
                        "Atlantico"
                    ],
                    "code": "ATL"
                },
                "Bolívar": {
                    "alternate_names": [
                        "Bolivar"
                    ],
                    "code": "BOL"
                },
                "Boyacá": {
                    "alternate_names": [
                        "Boyaca"
                    ],
                    "code": "BOY"
                },
                "Caldas": {
                    "code": "CAL"
                },
                "Caquetá": {
                    "alternate_names": [
                        "Caqueta"
                    ],
                    "code": "CAQ"
                },
                "Casanare": {
                    "code": "CAS"
                },
                "Cauca": {
                    "code": "CAU"
                },
                "Cesar": {
                    "code": "CES"
                },
                "Chocó": {
                    "alternate_names": [
                        "Choco"
                    ],
                    "code": "CHO"
                },
                "Córdoba": {
                    "alternate_names": [
                        "Cordoba"
                    ],
                    "code": "COR"
                },
                "Cundinamarca": {
                    "code": "CUN"
                },
                "Guainía": {
                    "alternate_names": [
                        "Guainia"
                    ],
                    "code": "GUA"
                },
                "Guaviare": {
                    "code": "GUV"
                },
                "Huila": {
                    "code": "HUI"
                },
                "La Guajira": {
                    "code": "LAG"
                },
                "Magdalena": {
                    "code": "MAG"
                },
                "Meta": {
                    "code": "MET"
                },
                "Nariño": {
                    "alternate_names": [
                        "Narino"
                    ],
                    "code": "NAR"
                },
                "Norte de Santander": {
                    "code": "NSA"
                },
                "Putumayo": {
                    "code": "PUT"
                },
                "Quindío": {
                    "alternate_names": [
                        "Quindio"
                    ],
                    "code": "QUI"
                },
                "Risaralda": {
                    "code": "RIS"
                },
                "Santander": {
                    "code": "SAN"
                },
                "Sucre": {
                    "code": "SUC"
                },
                "Tolima": {
                    "code": "TOL"
                },
                "Valle del Cauca": {
                    "code": "VAC"
                },
                "Vaupés": {
                    "alternate_names": [
                        "Vaupes"
                    ],
                    "code": "VAU"
                },
                "Vichada": {
                    "code": "VID"
                }
            }
        }
    ],
    [
        "Comoros",
        {
            "address_format": {
                "edit": 2
            },
            "code": "KM",
            "flag_path": "/assets/flags/km-e0b8c283cbfa1dabfcbc6a84f9eaa0cf7b98e67e08e2884deb13345960b1c992.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Congo",
        {
            "address_format": {
                "edit": 2
            },
            "code": "CG",
            "flag_path": "/assets/flags/cg-ce499eded190405e329ee02fe06a2142c4c5f225c27b862e64d7b6ed6a65251a.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Congo, The Democratic Republic Of The",
        {
            "address_format": {
                "edit": 2
            },
            "code": "CD",
            "flag_path": "/assets/flags/cd-cbc0de27d801ffd6cdec2bfdc104621f3db33217c02cf6c0fba592ad387bb16c.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Cook Islands",
        {
            "address_format": {
                "edit": 2
            },
            "code": "CK",
            "flag_path": "/assets/flags/ck-f34e9e0370f61d8834661d6013375c61a30479baa5fd43b9ed6d0839948f1703.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Costa Rica",
        {
            "address_format": {
                "edit": 7
            },
            "code": "CR",
            "flag_path": "/assets/flags/cr-4d06c04357eb1e2d9e461eb140d2b88d86d8f528b8a3e7002f38a2ec6f133f62.svg",
            "labels": {
                "province": "Provincia",
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Heredia": {
                    "code": "CR-H"
                },
                "Limón": {
                    "alternate_names": [
                        "Limon"
                    ],
                    "code": "CR-L"
                },
                "Alajuela": {
                    "label": "Provincia de Alajuela",
                    "code": "CR-A"
                },
                "Cartago": {
                    "label": "Provincia de Cartago",
                    "code": "CR-C"
                },
                "Guanacaste": {
                    "label": "Provincia de Guanacaste",
                    "code": "CR-G"
                },
                "San José": {
                    "label": "Provincia de San José",
                    "alternate_names": [
                        "San Jose"
                    ],
                    "code": "CR-SJ"
                },
                "Puntarenas": {
                    "code": "CR-P"
                }
            }
        }
    ],
    [
        "Croatia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "HR",
            "flag_path": "/assets/flags/hr-27085a5bc2145e8e8546096e59df02df8beed47af2ee4183d26634088c7789fa.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Cuba",
        {
            "address_format": {
                "edit": 1
            },
            "code": "CU",
            "flag_path": "/assets/flags/cu-5922186ffd3d0098a8168f3d506f46643a347cd5d5f56e6e7f43003f6ed2d0c6.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Curaçao",
        {
            "address_format": {
                "edit": 2
            },
            "code": "CW",
            "flag_path": "/assets/flags/cw-9b7a286aa854af8d31c1a962a61065024d72c8ff55f254ccb27cde39fc0e779f.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Cyprus",
        {
            "address_format": {
                "edit": 1
            },
            "code": "CY",
            "flag_path": "/assets/flags/cy-8de4b337874974c39609fe26d411f7a677340a50a80358849b12345475b190e1.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Czech Republic",
        {
            "address_format": {
                "edit": 1
            },
            "code": "CZ",
            "flag_path": "/assets/flags/cz-6724aa2d62c2e9c4dd9fda5688e0f1109067d7fbcc800fca4663a6845f56d714.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Côte d'Ivoire",
        {
            "address_format": {
                "edit": 2
            },
            "code": "CI",
            "flag_path": "/assets/flags/ci-aaf7093dc7c4b1e65d6cd0a65cf20dc957971205a04985897fb3980bccb3a394.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Denmark",
        {
            "address_format": {
                "edit": 1
            },
            "code": "DK",
            "flag_path": "/assets/flags/dk-d18d6ed60a97e1e05f5a35086ee38eb88f748c7ef805df38529498af1fabf4b8.svg",
            "labels": {
                "address1": "Calle y número de casa"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Djibouti",
        {
            "address_format": {
                "edit": 2
            },
            "code": "DJ",
            "flag_path": "/assets/flags/dj-3c59dd181f5701aebb4c1602ae39430932a1075ee1d23d3aaea221c3ed45584f.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Dominica",
        {
            "address_format": {
                "edit": 2
            },
            "code": "DM",
            "flag_path": "/assets/flags/dm-f5a013ee9a4315adaa5a524869d62d64199ddc8326bc983efa633e008923c0f2.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Dominican Republic",
        {
            "address_format": {
                "edit": 1
            },
            "code": "DO",
            "flag_path": "/assets/flags/do-7156442e9fff3130b30daf8472cad30302a6f59637c987edf0fa044819f41c8a.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Ecuador",
        {
            "address_format": {
                "edit": 1
            },
            "code": "EC",
            "flag_path": "/assets/flags/ec-0b782ce386a314ec08e5afd000deb54ccdb5d8aefd05f97e565573eb7eb67082.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Egypt",
        {
            "address_format": {
                "edit": 4
            },
            "code": "EG",
            "flag_path": "/assets/flags/eg-4f49a3b49f75441cee01321b29d91875a7ef0d4a9692c05b428faca9cad97a31.svg",
            "labels": {
                "province": "Provincia",
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "6th of October": {
                    "label": "6 de octubre",
                    "alternate_names": [
                        "As Sādis min Uktūbar",
                        "As Sadis min Uktubar"
                    ],
                    "code": "SU"
                },
                "Alexandria": {
                    "label": "Alejandría",
                    "alternate_names": [
                        "Al Iskandarīyah",
                        "Al Iskandariyah"
                    ],
                    "code": "ALX"
                },
                "Asyut": {
                    "label": "Asiut",
                    "alternate_names": [
                        "Asyūţ"
                    ],
                    "code": "AST"
                },
                "Aswan": {
                    "label": "Asuán",
                    "alternate_names": [
                        "Aswān"
                    ],
                    "code": "ASN"
                },
                "Beheira": {
                    "label": "Behera",
                    "alternate_names": [
                        "Al Buḩayrah",
                        "Al Buayrah"
                    ],
                    "code": "BH"
                },
                "Beni Suef": {
                    "alternate_names": [
                        "Banī Suwayf",
                        "Bani Suwayf"
                    ],
                    "code": "BNS"
                },
                "Qalyubia": {
                    "label": "Caliubia",
                    "alternate_names": [
                        "Al Qalyūbīyah",
                        "Al Qalyubiyah"
                    ],
                    "code": "KB"
                },
                "Dakahlia": {
                    "label": "Dacalia",
                    "alternate_names": [
                        "Ad Daqahlīyah",
                        "Ad Daqahliyah"
                    ],
                    "code": "DK"
                },
                "Damietta": {
                    "label": "Damieta",
                    "alternate_names": [
                        "Dumyāţ",
                        "Dumyat"
                    ],
                    "code": "DT"
                },
                "Cairo": {
                    "label": "El Cairo",
                    "alternate_names": [
                        "Al Qāhirah",
                        "Al Qahirah"
                    ],
                    "code": "C"
                },
                "Faiyum": {
                    "label": "Fayún",
                    "alternate_names": [
                        "Al Fayyūm",
                        "Al Fayyum"
                    ],
                    "code": "FYM"
                },
                "Suez": {
                    "label": "Gobernación de Suez",
                    "alternate_names": [
                        "As Suways"
                    ],
                    "code": "SUZ"
                },
                "Giza": {
                    "label": "Guiza",
                    "alternate_names": [
                        "Al Jīzah",
                        "Al Jizah"
                    ],
                    "code": "GZ"
                },
                "Helwan": {
                    "alternate_names": [
                        "Ḩulwān",
                        "ulwan"
                    ],
                    "code": "HU"
                },
                "Ismailia": {
                    "alternate_names": [
                        "Al Ismāٰīlīyah",
                        "Al Ismailiyah"
                    ],
                    "code": "IS"
                },
                "Kafr el-Sheikh": {
                    "label": "Kafr el Sheij",
                    "alternate_names": [
                        "Kafr ash Shaykh"
                    ],
                    "code": "KFS"
                },
                "Luxor": {
                    "label": "Lúxor",
                    "alternate_names": [
                        "Al Uqşur",
                        "Al Uqsur"
                    ],
                    "code": "LX"
                },
                "Red Sea": {
                    "label": "Mar Rojo",
                    "alternate_names": [
                        "Al Baḩr al Aḩmar",
                        "Al Bar al Amar"
                    ],
                    "code": "BA"
                },
                "Matrouh": {
                    "label": "Matrú",
                    "alternate_names": [
                        "Maţrūḩ",
                        "Matru"
                    ],
                    "code": "MT"
                },
                "Minya": {
                    "label": "Menia",
                    "alternate_names": [
                        "Al Minyā",
                        "Al Minya"
                    ],
                    "code": "MN"
                },
                "Monufia": {
                    "label": "Menufia",
                    "alternate_names": [
                        "Al Minūfīyah",
                        "Al Minufiyah"
                    ],
                    "code": "MNF"
                },
                "New Valley": {
                    "label": "Nuevo Valle",
                    "alternate_names": [
                        "Al Wādī al Jadīd",
                        "Al Wadi al Jadid"
                    ],
                    "code": "WAD"
                },
                "Gharbia": {
                    "label": "Occidental",
                    "alternate_names": [
                        "Al Gharbīyah",
                        "Al Gharbiyah"
                    ],
                    "code": "GH"
                },
                "Al Sharqia": {
                    "label": "Oriental",
                    "alternate_names": [
                        "Ash Sharqīyah",
                        "Ash Sharqiyah"
                    ],
                    "code": "SHR"
                },
                "Port Said": {
                    "label": "Puerto Saíd",
                    "alternate_names": [
                        "Būr Saٰīd",
                        "Bur Said"
                    ],
                    "code": "PTS"
                },
                "Qena": {
                    "label": "Quena",
                    "alternate_names": [
                        "Qinā",
                        "Qina"
                    ],
                    "code": "KN"
                },
                "North Sinai": {
                    "label": "Sinaí del Norte",
                    "alternate_names": [
                        "Shamāl Sīnā",
                        "Shamal Sina"
                    ],
                    "code": "SIN"
                },
                "South Sinai": {
                    "label": "Sinaí del Sur",
                    "alternate_names": [
                        "Janūb Sīnā",
                        "Janub Sina"
                    ],
                    "code": "JS"
                },
                "Sohag": {
                    "label": "Suhag",
                    "alternate_names": [
                        "Sūhāj",
                        "Suhaj"
                    ],
                    "code": "SHG"
                }
            }
        }
    ],
    [
        "El Salvador",
        {
            "address_format": {
                "edit": 8
            },
            "code": "SV",
            "flag_path": "/assets/flags/sv-b5c497657fc107f310d7b3b7cd8bb5fe4ac795a35efee075a7645286fecf7f69.svg",
            "labels": {
                "province": "Departamento",
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Ahuachapán": {
                    "alternate_names": [
                        "Ahuachapan"
                    ],
                    "code": "SV-AH"
                },
                "Cabañas": {
                    "alternate_names": [
                        "Cabanas"
                    ],
                    "code": "SV-CA"
                },
                "Chalatenango": {
                    "code": "SV-CH"
                },
                "Cuscatlán": {
                    "alternate_names": [
                        "Cuscatlan"
                    ],
                    "code": "SV-CU"
                },
                "La Libertad": {
                    "code": "SV-LI"
                },
                "La Paz": {
                    "code": "SV-PA"
                },
                "La Unión": {
                    "alternate_names": [
                        "La Union"
                    ],
                    "code": "SV-UN"
                },
                "Morazán": {
                    "alternate_names": [
                        "Morazan"
                    ],
                    "code": "SV-MO"
                },
                "San Miguel": {
                    "code": "SV-SM"
                },
                "San Salvador": {
                    "code": "SV-SS"
                },
                "San Vicente": {
                    "code": "SV-SV"
                },
                "Santa Ana": {
                    "code": "SV-SA"
                },
                "Sonsonate": {
                    "code": "SV-SO"
                },
                "Usulután": {
                    "alternate_names": [
                        "Usulutan"
                    ],
                    "code": "SV-US"
                }
            }
        }
    ],
    [
        "Equatorial Guinea",
        {
            "address_format": {
                "edit": 2
            },
            "code": "GQ",
            "flag_path": "/assets/flags/gq-d598e41d23a4eedc3cab52a4d16325b8ce7d67c9f65b9263614ef40e6da4613d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Eritrea",
        {
            "address_format": {
                "edit": 2
            },
            "code": "ER",
            "flag_path": "/assets/flags/er-0fd4d5f31f9d3e8b4adb707f6220b44f34213c560d00a0434b84834db188e2ef.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Estonia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "EE",
            "flag_path": "/assets/flags/ee-78a084bbebbd9e272bd9fdb1c016e91b0c2e5ce7923f7a990f9232a99e76799b.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Eswatini",
        {
            "address_format": {
                "edit": 0
            },
            "code": "SZ",
            "flag_path": "/assets/flags/sz-ff1aba207b351f7c045037ba506c62aeb493c489742e58a59982a72af44e5c4e.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Ethiopia",
        {
            "address_format": {
                "edit": 0
            },
            "code": "ET",
            "flag_path": "/assets/flags/et-f1feaa7f773dfaf2e95787788922d4e4c768170fb3764860a26ec548a2acbd05.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Falkland Islands (Malvinas)",
        {
            "address_format": {
                "edit": 2
            },
            "code": "FK",
            "flag_path": "/assets/flags/fk-f99b6453a575af42bb6f36262d5746992b4371d0ac0160e56aee212850acc15e.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Faroe Islands",
        {
            "address_format": {
                "edit": 1
            },
            "code": "FO",
            "flag_path": "/assets/flags/fo-588bc3a46afe6995f2001f8e5a2ab9ffbf3b689d5b47e41c61094c3076a88ce0.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Fiji",
        {
            "address_format": {
                "edit": 2
            },
            "code": "FJ",
            "flag_path": "/assets/flags/fj-310e62e8aed88acf97f5f410a3f999a378bb5a5bec74b2caebb0e59281c43877.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Finland",
        {
            "address_format": {
                "edit": 1
            },
            "code": "FI",
            "flag_path": "/assets/flags/fi-292dcc210743d9283848e4c5625691fc379675bd927779a71db1acc89014cd48.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "France",
        {
            "address_format": {
                "edit": 1
            },
            "code": "FR",
            "flag_path": "/assets/flags/fr-86634673b98e663eff937c29495ffcaceb34e678b1c2cad2e41a1ea5e6157b2d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "French Guiana",
        {
            "address_format": {
                "edit": 1
            },
            "code": "GF",
            "flag_path": "/assets/flags/gf-e308d163748965ced6eb6ca3751394efda518f821182f8244f7538cac7e6c866.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "French Polynesia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "PF",
            "flag_path": "/assets/flags/pf-9b67f3880510db1a736d1603d95c157af3b42738b18cf5cf7690f3ed49e4cdea.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "French Southern Territories",
        {
            "address_format": {
                "edit": 0
            },
            "code": "TF",
            "flag_path": "/assets/flags/tf-53cdbf16d5a48aec5d6b322090e9638bbd237109353cde315cd95d0c8ca223de.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Gabon",
        {
            "address_format": {
                "edit": 2
            },
            "code": "GA",
            "flag_path": "/assets/flags/ga-43e2be0bceff86a5e9611d197478256416e2ed1b106b9df24651d553bc87b41f.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Gambia",
        {
            "address_format": {
                "edit": 2
            },
            "code": "GM",
            "flag_path": "/assets/flags/gm-239a841ce1df4bef3e8f2959edcb232b4c5d3ce54d06fd6e3308bbc04e85a80c.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Georgia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "GE",
            "flag_path": "/assets/flags/ge-0023efb04296eadc48759e5cd10d727eeaf19d916b114b22735a48a20abb0b0d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Germany",
        {
            "address_format": {
                "edit": 1
            },
            "code": "DE",
            "flag_path": "/assets/flags/de-4f5f2caaa754bf3aa10c5d6fefe4270a02974bf787f3ed25aa36476fd809d790.svg",
            "labels": {
                "address1": "Calle y número de casa",
                "address2": "Dirección adicional (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Ghana",
        {
            "address_format": {
                "edit": 0
            },
            "code": "GH",
            "flag_path": "/assets/flags/gh-598df21d6b02a3c09206ce44b54fefec8d9fae2ec8d090839f3eb42cbf4f1cb7.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Gibraltar",
        {
            "address_format": {
                "edit": 9
            },
            "code": "GI",
            "flag_path": "/assets/flags/gi-0cbb5edc90c22e90d799efc0fd2865ff5ebac74b3c63c0a55a132e3125c4612b.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Greece",
        {
            "address_format": {
                "edit": 1
            },
            "code": "GR",
            "flag_path": "/assets/flags/gr-5f4329f8f52e2245abc67845b7242a2426f13be0086a0414f96c42d46deb56e4.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Greenland",
        {
            "address_format": {
                "edit": 1
            },
            "code": "GL",
            "flag_path": "/assets/flags/gl-85414ac715bebe51aa734a2978b07d4fd33c4bfc8aa2756bbb81375f09d7c28b.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Grenada",
        {
            "address_format": {
                "edit": 2
            },
            "code": "GD",
            "flag_path": "/assets/flags/gd-3d608f48bd056a73fb7aa51d91f99aef2c4e9820473edf462709106e6a2697b5.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Guadeloupe",
        {
            "address_format": {
                "edit": 1
            },
            "code": "GP",
            "flag_path": "/assets/flags/gp-a6eeec59f2b86639cfc5437151dfcba8487cc2de1025bdcb8dfc3688f269186e.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Guatemala",
        {
            "address_format": {
                "edit": 4
            },
            "code": "GT",
            "flag_path": "/assets/flags/gt-6943ef51f7dbc6dbeeaae28c5d62689773e4aac2c1042cf206d84cd4ad3523ee.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Alta Verapaz": {
                    "code": "AVE"
                },
                "Baja Verapaz": {
                    "code": "BVE"
                },
                "Chimaltenango": {
                    "code": "CMT"
                },
                "Chiquimula": {
                    "code": "CQM"
                },
                "El Progreso": {
                    "code": "EPR"
                },
                "Escuintla": {
                    "code": "ESC"
                },
                "Guatemala": {
                    "code": "GUA"
                },
                "Huehuetenango": {
                    "code": "HUE"
                },
                "Izabal": {
                    "code": "IZA"
                },
                "Jalapa": {
                    "code": "JAL"
                },
                "Jutiapa": {
                    "code": "JUT"
                },
                "Petén": {
                    "alternate_names": [
                        "Peten"
                    ],
                    "code": "PET"
                },
                "Quetzaltenango": {
                    "code": "QUE"
                },
                "Quiché": {
                    "alternate_names": [
                        "Quiche"
                    ],
                    "code": "QUI"
                },
                "Retalhuleu": {
                    "code": "RET"
                },
                "Sacatepéquez": {
                    "alternate_names": [
                        "Sacatepequez"
                    ],
                    "code": "SAC"
                },
                "San Marcos": {
                    "code": "SMA"
                },
                "Santa Rosa": {
                    "code": "SRO"
                },
                "Sololá": {
                    "alternate_names": [
                        "Solola"
                    ],
                    "code": "SOL"
                },
                "Suchitepéquez": {
                    "alternate_names": [
                        "Suchitepequez"
                    ],
                    "code": "SUC"
                },
                "Totonicapán": {
                    "alternate_names": [
                        "Totonicapan"
                    ],
                    "code": "TOT"
                },
                "Zacapa": {
                    "code": "ZAC"
                }
            }
        }
    ],
    [
        "Guernsey",
        {
            "address_format": {
                "edit": 0
            },
            "code": "GG",
            "flag_path": "/assets/flags/gg-3b6932c7289063e526a5f163e97f10f86deb9c20b0d2bb2190d00a2e5b2a1c20.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Guinea",
        {
            "address_format": {
                "edit": 0
            },
            "code": "GN",
            "flag_path": "/assets/flags/gn-4932e18d832d6a781bc00400b69136cc9406234d3800e1e66ea809550a84b423.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Guinea Bissau",
        {
            "address_format": {
                "edit": 1
            },
            "code": "GW",
            "flag_path": "/assets/flags/gw-be68548eb8019fd61dd32bb0ac8e2367272d27064ba1c883f2b042e01cbf4174.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Guyana",
        {
            "address_format": {
                "edit": 2
            },
            "code": "GY",
            "flag_path": "/assets/flags/gy-79ea9aad986003d5ae61672024630b3a0a3978ef3fd0d5b5cd156495761ac078.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Haiti",
        {
            "address_format": {
                "edit": 1
            },
            "code": "HT",
            "flag_path": "/assets/flags/ht-a3912677d647ea20938000dc0285be6aa9d413b0c195675ef9ec0dbe0d9f17fa.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Heard Island And Mcdonald Islands",
        {
            "address_format": {
                "edit": 0
            },
            "code": "HM",
            "flag_path": "/assets/flags/hm-777847adcc7320aae16afbaa3c8b45394f616ee81bfd3344e6c62ae4d60cfe09.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Holy See (Vatican City State)",
        {
            "address_format": {
                "edit": 9
            },
            "code": "VA",
            "flag_path": "/assets/flags/va-9dc76a1c31b5a8007f0d665c022535a06d52675d5c3e6b31fd2cf67eae7e0d96.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Honduras",
        {
            "address_format": {
                "edit": 1
            },
            "code": "HN",
            "flag_path": "/assets/flags/hn-dc74dc68644856be310515e4980ed556f8b9005d9d8cd58985161ceb3ab91b3a.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Hong Kong",
        {
            "address_format": {
                "edit": 10
            },
            "code": "HK",
            "flag_path": "/assets/flags/hk-0d5f8eaa45c46598aab66a8b57431dfecfcf1e1b247ce1b107bbb36863cca822.svg",
            "labels": {
                "city": "Distrito"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Kowloon": {
                    "alternate_names": [
                        "九龍"
                    ],
                    "code": "KL"
                },
                "Hong Kong Island": {
                    "label": "La isla de Hong Kong",
                    "alternate_names": [
                        "Hong Kong Province",
                        "Hong Kong",
                        "香港",
                        "香港島"
                    ],
                    "code": "HK"
                },
                "New Territories": {
                    "label": "Nuevos Territorios",
                    "alternate_names": [
                        "新界"
                    ],
                    "code": "NT"
                }
            }
        }
    ],
    [
        "Hungary",
        {
            "address_format": {
                "edit": 11
            },
            "code": "HU",
            "flag_path": "/assets/flags/hu-85436dbd9e2d34b2151ddef42e8af89df2e61129523710f335d941cbd6663b12.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Iceland",
        {
            "address_format": {
                "edit": 1
            },
            "code": "IS",
            "flag_path": "/assets/flags/is-9fa0163a367703d4a2d1e4807dbc88f03697d5ab2d655ca090e45d36445d789e.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "India",
        {
            "address_format": {
                "edit": 4
            },
            "code": "IN",
            "flag_path": "/assets/flags/in-c7a646ea82c2c97e30194e3ad0834505bb86ca088596a0790a49b4b03ac1e866.svg",
            "labels": {
                "province": "Estado",
                "zip": "Número de índice postal"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Andhra Pradesh": {
                    "code": "AP"
                },
                "Arunachal Pradesh": {
                    "code": "AR"
                },
                "Assam": {
                    "code": "AS"
                },
                "West Bengal": {
                    "label": "Bengala Occidental",
                    "code": "WB"
                },
                "Bihar": {
                    "code": "BR"
                },
                "Chandigarh": {
                    "code": "CH"
                },
                "Chhattisgarh": {
                    "alternate_names": [
                        "Chattisgarh",
                        "CT"
                    ],
                    "code": "CG"
                },
                "Dadra and Nagar Haveli": {
                    "label": "Dadra y Nagar Haveli",
                    "code": "DN"
                },
                "Daman and Diu": {
                    "label": "Damán y Diu",
                    "code": "DD"
                },
                "Delhi": {
                    "code": "DL"
                },
                "Goa": {
                    "code": "GA"
                },
                "Gujarat": {
                    "label": "Guyarat",
                    "code": "GJ"
                },
                "Haryana": {
                    "code": "HR"
                },
                "Himachal Pradesh": {
                    "code": "HP"
                },
                "Andaman and Nicobar Islands": {
                    "label": "Islas Andamán y Nicobar",
                    "alternate_names": [
                        "Andaman and Nicobar"
                    ],
                    "code": "AN"
                },
                "Jammu and Kashmir": {
                    "label": "Jammu y Cachemira",
                    "code": "JK"
                },
                "Jharkhand": {
                    "code": "JH"
                },
                "Karnataka": {
                    "code": "KA"
                },
                "Kerala": {
                    "code": "KL"
                },
                "Ladakh": {
                    "code": "LA"
                },
                "Lakshadweep": {
                    "label": "Laquedivas",
                    "code": "LD"
                },
                "Madhya Pradesh": {
                    "code": "MP"
                },
                "Maharashtra": {
                    "label": "Maharastra",
                    "code": "MH"
                },
                "Manipur": {
                    "code": "MN"
                },
                "Meghalaya": {
                    "label": "Megalaya",
                    "code": "ML"
                },
                "Mizoram": {
                    "label": "Mizorán",
                    "code": "MZ"
                },
                "Nagaland": {
                    "code": "NL"
                },
                "Odisha": {
                    "alternate_names": [
                        "OD",
                        "Orissa"
                    ],
                    "code": "OR"
                },
                "Puducherry": {
                    "code": "PY"
                },
                "Punjab": {
                    "label": "Punyab",
                    "code": "PB"
                },
                "Rajasthan": {
                    "label": "Rajastán",
                    "code": "RJ"
                },
                "Sikkim": {
                    "code": "SK"
                },
                "Tamil Nadu": {
                    "code": "TN"
                },
                "Telangana": {
                    "label": "Telingana",
                    "code": "TS"
                },
                "Tripura": {
                    "code": "TR"
                },
                "Uttar Pradesh": {
                    "code": "UP"
                },
                "Uttarakhand": {
                    "code": "UK"
                }
            }
        }
    ],
    [
        "Indonesia",
        {
            "address_format": {
                "edit": 12
            },
            "code": "ID",
            "flag_path": "/assets/flags/id-2ab57d2d418baba7b0ff55729435d0c780ca52a98b754f92d44e96cd1399dae5.svg",
            "labels": {
                "province": "Provincia"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Aceh": {
                    "code": "AC"
                },
                "Bangka Belitung": {
                    "label": "Bangka-Belitung",
                    "code": "BB"
                },
                "Banten": {
                    "label": "Bantén",
                    "code": "BT"
                },
                "Bengkulu": {
                    "code": "BE"
                },
                "Kalimantan Tengah": {
                    "label": "Borneo Central",
                    "code": "KT"
                },
                "Kalimantan Selatan": {
                    "label": "Borneo Meridional",
                    "code": "KS"
                },
                "Kalimantan Barat": {
                    "label": "Borneo Occidental",
                    "code": "KB"
                },
                "Sulawesi Tengah": {
                    "label": "Célebes Central",
                    "code": "ST"
                },
                "Sulawesi Selatan": {
                    "label": "Célebes Meridional",
                    "code": "SN"
                },
                "Sulawesi Barat": {
                    "label": "Célebes Occidental",
                    "code": "SR"
                },
                "Sulawesi Utara": {
                    "label": "Célebes Septentrional",
                    "code": "SA"
                },
                "Sulawesi Tenggara": {
                    "label": "Célebes Suroriental",
                    "code": "SG"
                },
                "Gorontalo": {
                    "code": "GO"
                },
                "Kepulauan Riau": {
                    "label": "Islas Riau",
                    "code": "KR"
                },
                "Jambi": {
                    "code": "JA"
                },
                "Jawa Tengah": {
                    "label": "Java Central",
                    "code": "JT"
                },
                "Jawa Barat": {
                    "label": "Java Occidental",
                    "code": "JB"
                },
                "Jawa Timur": {
                    "label": "Java Oriental",
                    "code": "JI"
                },
                "Kalimantan Timur": {
                    "label": "Kalimantan Oriental",
                    "code": "KI"
                },
                "Kalimantan Utara": {
                    "label": "Kalimantán Septentrional",
                    "code": "KU"
                },
                "Lampung": {
                    "code": "LA"
                },
                "Maluku": {
                    "label": "Molucas",
                    "code": "MA"
                },
                "Maluku Utara": {
                    "label": "Molucas Septentrional",
                    "code": "MU"
                },
                "Nusa Tenggara Barat": {
                    "label": "Nusatenggara Occidental",
                    "code": "NB"
                },
                "Nusa Tenggara Timur": {
                    "label": "Nusatenggara Oriental",
                    "code": "NT"
                },
                "Papua": {
                    "label": "Papúa",
                    "code": "PA"
                },
                "Papua Barat": {
                    "label": "Papúa Occidental",
                    "code": "PB"
                },
                "Bali": {
                    "label": "Provincia de Bali",
                    "code": "BA"
                },
                "Riau": {
                    "code": "RI"
                },
                "South Sumatra": {
                    "label": "Sumatra Meridional",
                    "alternate_names": [
                        "Sumatra Selatan"
                    ],
                    "code": "SS"
                },
                "West Sumatra": {
                    "label": "Sumatra Occidental",
                    "alternate_names": [
                        "Sumatra Barat"
                    ],
                    "code": "SB"
                },
                "North Sumatra": {
                    "label": "Sumatra Septentrional",
                    "alternate_names": [
                        "Sumatra Utara"
                    ],
                    "code": "SU"
                },
                "Jakarta": {
                    "label": "Yakarta",
                    "code": "JK"
                },
                "Yogyakarta": {
                    "code": "YO"
                }
            }
        }
    ],
    [
        "Iran, Islamic Republic Of",
        {
            "address_format": {
                "edit": 1
            },
            "code": "IR",
            "flag_path": "/assets/flags/ir-febc5effae78c0c567b6435fd87cfa2d8a9ff5c70cd0935519777ad2a19941d9.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Iraq",
        {
            "address_format": {
                "edit": 0
            },
            "code": "IQ",
            "flag_path": "/assets/flags/iq-49cea19ad86eec0303166d3924af20bf0e227b8746a99f2b89ae6fb3e25f7d71.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Ireland",
        {
            "address_format": {
                "edit": 4
            },
            "code": "IE",
            "flag_path": "/assets/flags/ie-b848b4a1d8e7b9ce5bb7d60385e50bfd1a074aaec4e3355c9c2d1821c5b2140e.svg",
            "labels": {
                "province": "Condado"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Carlow": {
                    "label": "Condado de Carlow",
                    "alternate_names": [
                        "Ceatharlach",
                        "Contae Cheatharlach",
                        "County Carlow",
                        "Co. Carlow"
                    ],
                    "code": "CW"
                },
                "Cavan": {
                    "label": "Condado de Cavan",
                    "alternate_names": [
                        "An Cabhán",
                        "An Cabhan",
                        "Contae an Chabháin",
                        "Contae an Chabhain",
                        "County Cavan",
                        "Co. Cavan"
                    ],
                    "code": "CN"
                },
                "Clare": {
                    "label": "Condado de Clare",
                    "alternate_names": [
                        "An Clár",
                        "An Clar",
                        "Contae an Chláir",
                        "Contae an Chlair",
                        "County Clare",
                        "Co. Clare"
                    ],
                    "code": "CE"
                },
                "Cork": {
                    "label": "Condado de Cork",
                    "alternate_names": [
                        "Corcaigh",
                        "Contae Chorcaí",
                        "Contae Chorcai",
                        "County Cork",
                        "Co. Cork"
                    ],
                    "code": "CO"
                },
                "Donegal": {
                    "label": "Condado de Donegal",
                    "alternate_names": [
                        "Dún na nGall",
                        "Dun na nGall",
                        "Contae Dhún na nGall",
                        "Contae Dhun na nGall",
                        "County Donegal",
                        "Co. Donegal"
                    ],
                    "code": "DL"
                },
                "Dublin": {
                    "label": "Condado de Dublín",
                    "alternate_names": [
                        "Baile Átha Cliath",
                        "Baile Atha Cliath",
                        "County Dublin",
                        "Co. Dublin"
                    ],
                    "code": "D"
                },
                "Galway": {
                    "label": "Condado de Galway",
                    "alternate_names": [
                        "Gaillimh",
                        "Contae na Gaillimhe",
                        "County Galway",
                        "Co. Galway"
                    ],
                    "code": "G"
                },
                "Kerry": {
                    "label": "Condado de Kerry",
                    "alternate_names": [
                        "Ciarraí",
                        "Ciarrai",
                        "Contae Chiarraí",
                        "Contae Chiarrai",
                        "County Kerry",
                        "Co. Kerry"
                    ],
                    "code": "KY"
                },
                "Kildare": {
                    "label": "Condado de Kildare",
                    "alternate_names": [
                        "Cill Dara",
                        "Contae Chill Dara",
                        "County Kildare",
                        "Co. Kildare"
                    ],
                    "code": "KE"
                },
                "Kilkenny": {
                    "label": "Condado de Kilkenny",
                    "alternate_names": [
                        "Cill Chainnigh",
                        "Contae Chill Chainnigh",
                        "County Kilkenny",
                        "Co. Kilkenny"
                    ],
                    "code": "KK"
                },
                "Laois": {
                    "label": "Condado de Laois",
                    "alternate_names": [
                        "Contae Laoise",
                        "County Laois",
                        "Co. Laois"
                    ],
                    "code": "LS"
                },
                "Leitrim": {
                    "label": "Condado de Leitrim",
                    "alternate_names": [
                        "Liatroim",
                        "Contae Liatroma",
                        "County Leitrim",
                        "Co. Leitrim"
                    ],
                    "code": "LM"
                },
                "Limerick": {
                    "label": "Condado de Limerick",
                    "alternate_names": [
                        "Luimneach",
                        "Contae Luimnigh",
                        "County Limerick",
                        "Co. Limerick"
                    ],
                    "code": "LK"
                },
                "Longford": {
                    "label": "Condado de Longford",
                    "alternate_names": [
                        "An Longfort",
                        "Contae an Longfoirt",
                        "County Longford",
                        "Co. Longford"
                    ],
                    "code": "LD"
                },
                "Louth": {
                    "label": "Condado de Louth",
                    "alternate_names": [
                        "Lú",
                        "Lu",
                        "Contae Lú",
                        "Contae Lu",
                        "County Louth",
                        "Co. Louth"
                    ],
                    "code": "LH"
                },
                "Mayo": {
                    "label": "Condado de Mayo",
                    "alternate_names": [
                        "Maigh Eo",
                        "Contae Mhaigh Eo",
                        "County Mayo",
                        "Co. Mayo"
                    ],
                    "code": "MO"
                },
                "Meath": {
                    "label": "Condado de Meath",
                    "alternate_names": [
                        "An Mhí",
                        "An Mhi",
                        "Contae na Mí",
                        "Contae na Mi",
                        "County Meath",
                        "Co. Meath"
                    ],
                    "code": "MH"
                },
                "Monaghan": {
                    "label": "Condado de Monaghan",
                    "alternate_names": [
                        "Muineachán",
                        "Muineachan",
                        "Contae Mhuineacháin",
                        "Contae Mhuineachain",
                        "County Monaghan",
                        "Co. Monaghan"
                    ],
                    "code": "MN"
                },
                "Offaly": {
                    "label": "Condado de Offaly",
                    "alternate_names": [
                        "Uíbh Fhailí",
                        "Uibh Fhaili",
                        "Contae Uíbh Fhailí",
                        "Contae Uibh Fhaili",
                        "County Offaly",
                        "Co. Offaly"
                    ],
                    "code": "OY"
                },
                "Roscommon": {
                    "label": "Condado de Roscommon",
                    "alternate_names": [
                        "Ros Comáin",
                        "Ros Comain",
                        "Contae Ros Comáin",
                        "Contae Ros Comain",
                        "County Roscommon",
                        "Co. Roscommon"
                    ],
                    "code": "RN"
                },
                "Sligo": {
                    "label": "Condado de Sligo",
                    "alternate_names": [
                        "Sligeach",
                        "Contae Shligigh",
                        "County Sligo",
                        "Co. Sligo"
                    ],
                    "code": "SO"
                },
                "Tipperary": {
                    "label": "Condado de Tipperary",
                    "alternate_names": [
                        "Tiobraid Árann",
                        "Tiobraid Arann",
                        "Contae Thiobraid Árann",
                        "Contae Thiobraid Arann",
                        "County Tipperary",
                        "Co. Tipperary"
                    ],
                    "code": "TA"
                },
                "Westmeath": {
                    "label": "Condado de Westmeath",
                    "alternate_names": [
                        "An Iarmhí",
                        "An Iarmhi",
                        "Contae na hIarmhí",
                        "Contae na hIarmhi",
                        "County Westmeath",
                        "Co. Westmeath"
                    ],
                    "code": "WH"
                },
                "Wexford": {
                    "label": "Condado de Wexford",
                    "alternate_names": [
                        "Loch Garman",
                        "Contae Loch Garman",
                        "County Wexford",
                        "Co. Wexford"
                    ],
                    "code": "WX"
                },
                "Wicklow": {
                    "label": "Condado de Wicklow",
                    "alternate_names": [
                        "Cill Mhantáin",
                        "Cill Mhantain",
                        "Contae Chill Mhantáin",
                        "Contae Chill Mhantain",
                        "County Wicklow",
                        "Co. Wicklow"
                    ],
                    "code": "WW"
                },
                "Waterford": {
                    "alternate_names": [
                        "Port Láirge",
                        "Port Lairge",
                        "Contae Phort Láirge",
                        "Contae Phort Lairge",
                        "County Waterford",
                        "Co. Waterford"
                    ],
                    "code": "WD"
                }
            }
        }
    ],
    [
        "Isle Of Man",
        {
            "address_format": {
                "edit": 0
            },
            "code": "IM",
            "flag_path": "/assets/flags/im-8ffb15cb53484c2c89e43bb435d7e1f038b0f50b0f32cfd742c3d5832a22e563.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Israel",
        {
            "address_format": {
                "edit": 1
            },
            "code": "IL",
            "flag_path": "/assets/flags/il-a5732410968d238f8a506a455bd7be7fea2908d0abcf638020fbe7b58bd4ad2f.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Italy",
        {
            "address_format": {
                "edit": 3
            },
            "code": "IT",
            "flag_path": "/assets/flags/it-da9adb7b75de4b34efbb8e842ca407b71a82d00e35768578d9d8e0964ea185b7.svg",
            "labels": {
                "address1": "Calle y número de casa",
                "province": "Provincia"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Agrigento": {
                    "code": "AG"
                },
                "Alessandria": {
                    "code": "AL"
                },
                "Ancona": {
                    "code": "AN"
                },
                "Arezzo": {
                    "code": "AR"
                },
                "Ascoli Piceno": {
                    "code": "AP"
                },
                "Asti": {
                    "code": "AT"
                },
                "Avellino": {
                    "code": "AV"
                },
                "Bari": {
                    "code": "BA"
                },
                "Barletta-Andria-Trani": {
                    "code": "BT"
                },
                "Belluno": {
                    "code": "BL"
                },
                "Benevento": {
                    "code": "BN"
                },
                "Bergamo": {
                    "label": "Bérgamo",
                    "code": "BG"
                },
                "Biella": {
                    "code": "BI"
                },
                "Bologna": {
                    "label": "Bolonia",
                    "code": "BO"
                },
                "Bolzano": {
                    "code": "BZ"
                },
                "Brescia": {
                    "code": "BS"
                },
                "Brindisi": {
                    "code": "BR"
                },
                "Cagliari": {
                    "code": "CA"
                },
                "Caltanissetta": {
                    "code": "CL"
                },
                "Campobasso": {
                    "code": "CB"
                },
                "Carbonia-Iglesias": {
                    "code": "CI"
                },
                "Caserta": {
                    "code": "CE"
                },
                "Catania": {
                    "code": "CT"
                },
                "Catanzaro": {
                    "code": "CZ"
                },
                "Chieti": {
                    "code": "CH"
                },
                "Genova": {
                    "label": "Ciudad metropolitana de Génova",
                    "code": "GE"
                },
                "Napoli": {
                    "label": "Ciudad metropolitana de Nápoles",
                    "code": "NA"
                },
                "Como": {
                    "code": "CO"
                },
                "Cosenza": {
                    "code": "CS"
                },
                "Cremona": {
                    "code": "CR"
                },
                "Crotone": {
                    "label": "Crotona",
                    "code": "KR"
                },
                "Cuneo": {
                    "code": "CN"
                },
                "Enna": {
                    "code": "EN"
                },
                "Fermo": {
                    "code": "FM"
                },
                "Ferrara": {
                    "code": "FE"
                },
                "Firenze": {
                    "label": "Florencia",
                    "code": "FI"
                },
                "Foggia": {
                    "code": "FG"
                },
                "Forlì-Cesena": {
                    "alternate_names": [
                        "Forli-Cesena"
                    ],
                    "code": "FC"
                },
                "Frosinone": {
                    "code": "FR"
                },
                "Gorizia": {
                    "code": "GO"
                },
                "Grosseto": {
                    "code": "GR"
                },
                "Imperia": {
                    "code": "IM"
                },
                "Isernia": {
                    "code": "IS"
                },
                "La Spezia": {
                    "code": "SP"
                },
                "Latina": {
                    "code": "LT"
                },
                "Lecce": {
                    "code": "LE"
                },
                "Lecco": {
                    "code": "LC"
                },
                "Livorno": {
                    "code": "LI"
                },
                "Lodi": {
                    "code": "LO"
                },
                "Lucca": {
                    "code": "LU"
                },
                "L'Aquila": {
                    "label": "L’Aquila",
                    "code": "AQ"
                },
                "Macerata": {
                    "code": "MC"
                },
                "Mantova": {
                    "label": "Mantua",
                    "code": "MN"
                },
                "Massa-Carrara": {
                    "label": "Massa y Carrara",
                    "code": "MS"
                },
                "Matera": {
                    "code": "MT"
                },
                "Medio Campidano": {
                    "code": "VS"
                },
                "Messina": {
                    "label": "Mesina",
                    "code": "ME"
                },
                "Milano": {
                    "label": "Milán",
                    "code": "MI"
                },
                "Modena": {
                    "label": "Módena",
                    "code": "MO"
                },
                "Monza e Brianza": {
                    "label": "Monza y Brianza",
                    "code": "MB"
                },
                "Novara": {
                    "code": "NO"
                },
                "Nuoro": {
                    "code": "NU"
                },
                "Ogliastra": {
                    "code": "OG"
                },
                "Olbia-Tempio": {
                    "code": "OT"
                },
                "Oristano": {
                    "label": "Oristán",
                    "code": "OR"
                },
                "Padova": {
                    "label": "Padua",
                    "code": "PD"
                },
                "Palermo": {
                    "code": "PA"
                },
                "Parma": {
                    "code": "PR"
                },
                "Pavia": {
                    "label": "Pavía",
                    "code": "PV"
                },
                "Perugia": {
                    "code": "PG"
                },
                "Pesaro e Urbino": {
                    "label": "Pesaro y Urbino",
                    "code": "PU"
                },
                "Pescara": {
                    "code": "PE"
                },
                "Piacenza": {
                    "code": "PC"
                },
                "Pisa": {
                    "code": "PI"
                },
                "Pistoia": {
                    "code": "PT"
                },
                "Pordenone": {
                    "code": "PN"
                },
                "Potenza": {
                    "code": "PZ"
                },
                "Prato": {
                    "code": "PO"
                },
                "Ragusa": {
                    "code": "RG"
                },
                "Ravenna": {
                    "label": "Rávena",
                    "code": "RA"
                },
                "Reggio Calabria": {
                    "alternate_names": [
                        "Calabria"
                    ],
                    "code": "RC"
                },
                "Reggio Emilia": {
                    "code": "RE"
                },
                "Rieti": {
                    "code": "RI"
                },
                "Rimini": {
                    "label": "Rímini",
                    "code": "RN"
                },
                "Roma": {
                    "code": "RM"
                },
                "Rovigo": {
                    "code": "RO"
                },
                "Salerno": {
                    "code": "SA"
                },
                "Sassari": {
                    "code": "SS"
                },
                "Savona": {
                    "code": "SV"
                },
                "Siena": {
                    "code": "SI"
                },
                "Siracusa": {
                    "code": "SR"
                },
                "Sondrio": {
                    "code": "SO"
                },
                "Taranto": {
                    "label": "Tarento",
                    "code": "TA"
                },
                "Teramo": {
                    "code": "TE"
                },
                "Terni": {
                    "code": "TR"
                },
                "Trapani": {
                    "code": "TP"
                },
                "Trento": {
                    "code": "TN"
                },
                "Treviso": {
                    "code": "TV"
                },
                "Trieste": {
                    "code": "TS"
                },
                "Torino": {
                    "label": "Turín",
                    "code": "TO"
                },
                "Udine": {
                    "code": "UD"
                },
                "Aosta": {
                    "label": "Valle de Aosta",
                    "code": "AO"
                },
                "Varese": {
                    "code": "VA"
                },
                "Venezia": {
                    "label": "Venecia",
                    "code": "VE"
                },
                "Verbano-Cusio-Ossola": {
                    "code": "VB"
                },
                "Vercelli": {
                    "code": "VC"
                },
                "Verona": {
                    "code": "VR"
                },
                "Vibo Valentia": {
                    "code": "VV"
                },
                "Vicenza": {
                    "code": "VI"
                },
                "Viterbo": {
                    "code": "VT"
                }
            }
        }
    ],
    [
        "Jamaica",
        {
            "address_format": {
                "edit": 2
            },
            "code": "JM",
            "flag_path": "/assets/flags/jm-2a6196d36537bf991a0135602d1fbda4bf3a51a57f173218eed380c63e266bf4.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Japan",
        {
            "address_format": {
                "edit": 13
            },
            "code": "JP",
            "flag_path": "/assets/flags/jp-69a7f3d6a0cd7f6e5f85332c127fe4a344f24ae1df494506e30fd50c01832cc1.svg",
            "labels": {
                "city": "Ciudad/distrito/pueblo/aldea",
                "province": "Prefectura"
            },
            "autocompletion_field": "zip",
            "provinces": {
                "Hokkaidō": {
                    "alternate_names": [
                        "Hokkaido",
                        "Hokkaido Prefecture",
                        "北海道"
                    ],
                    "code": "JP-01"
                },
                "Aomori": {
                    "label": "Prefectura de Aomori",
                    "alternate_names": [
                        "Aomori Prefecture",
                        "Aomori-ken",
                        "青森県",
                        "青森"
                    ],
                    "code": "JP-02"
                },
                "Iwate": {
                    "label": "Prefectura de Iwate",
                    "alternate_names": [
                        "Iwate Prefecture",
                        "Iwate-ken",
                        "岩手県",
                        "岩手"
                    ],
                    "code": "JP-03"
                },
                "Miyagi": {
                    "alternate_names": [
                        "Miyagi Prefecture",
                        "Miyagi-ken",
                        "宮城県",
                        "宮城"
                    ],
                    "code": "JP-04"
                },
                "Akita": {
                    "alternate_names": [
                        "Akita Prefecture",
                        "Akita-ken",
                        "秋田県",
                        "秋田"
                    ],
                    "code": "JP-05"
                },
                "Yamagata": {
                    "label": "Prefectura de Yamagata",
                    "alternate_names": [
                        "Yamagata Prefecture",
                        "Yamagata-ken",
                        "山形県",
                        "山形"
                    ],
                    "code": "JP-06"
                },
                "Fukushima": {
                    "label": "Prefectura de Fukushima",
                    "alternate_names": [
                        "Fukushima Prefecture",
                        "Fukushima-ken",
                        "福島県",
                        "福島"
                    ],
                    "code": "JP-07"
                },
                "Ibaraki": {
                    "label": "Prefectura de Ibaraki",
                    "alternate_names": [
                        "Ibaraki Prefecture",
                        "Ibaraki-ken",
                        "茨城県",
                        "茨城"
                    ],
                    "code": "JP-08"
                },
                "Tochigi": {
                    "label": "Prefectura de Tochigi",
                    "alternate_names": [
                        "Tochigi Prefecture",
                        "Tochigi-ken",
                        "栃木県",
                        "栃木"
                    ],
                    "code": "JP-09"
                },
                "Gunma": {
                    "label": "Prefectura de Gunma",
                    "alternate_names": [
                        "Gunma Prefecture",
                        "Gunma-ken",
                        "群馬県",
                        "群馬"
                    ],
                    "code": "JP-10"
                },
                "Saitama": {
                    "label": "Prefectura de Saitama",
                    "alternate_names": [
                        "Saitama Prefecture",
                        "Saitama-ken",
                        "埼玉県",
                        "埼玉"
                    ],
                    "code": "JP-11"
                },
                "Chiba": {
                    "alternate_names": [
                        "Chiba Prefecture",
                        "Chiba-ken",
                        "千葉県",
                        "千葉"
                    ],
                    "code": "JP-12"
                },
                "Tōkyō": {
                    "label": "Tokio",
                    "alternate_names": [
                        "Tokyo",
                        "Tokyo Prefecture",
                        "Tōkyō-to",
                        "Tokyo-to",
                        "東京都",
                        "東京"
                    ],
                    "code": "JP-13"
                },
                "Kanagawa": {
                    "label": "Prefectura de Kanagawa",
                    "alternate_names": [
                        "Kanagawa Prefecture",
                        "Kanagawa-ken",
                        "神奈川県",
                        "神奈川"
                    ],
                    "code": "JP-14"
                },
                "Niigata": {
                    "label": "Prefectura de Niigata",
                    "alternate_names": [
                        "Niigata Prefecture",
                        "Niigata-ken",
                        "新潟県",
                        "新潟"
                    ],
                    "code": "JP-15"
                },
                "Toyama": {
                    "label": "Prefectura de Toyama",
                    "alternate_names": [
                        "Toyama Prefecture",
                        "Toyama-ken",
                        "富山県",
                        "富山"
                    ],
                    "code": "JP-16"
                },
                "Ishikawa": {
                    "label": "Prefectura de Ishikawa",
                    "alternate_names": [
                        "Ishikawa Prefecture",
                        "Ishikawa-ken",
                        "石川県",
                        "石川"
                    ],
                    "code": "JP-17"
                },
                "Fukui": {
                    "label": "Prefectura de Fukui",
                    "alternate_names": [
                        "Fukui Prefecture",
                        "Fukui-ken",
                        "福井県",
                        "福井"
                    ],
                    "code": "JP-18"
                },
                "Yamanashi": {
                    "label": "Prefectura de Yamanashi",
                    "alternate_names": [
                        "Yamanashi Prefecture",
                        "Yamanashi-ken",
                        "山梨県",
                        "山梨"
                    ],
                    "code": "JP-19"
                },
                "Nagano": {
                    "label": "Prefectura de Nagano",
                    "alternate_names": [
                        "Nagano Prefecture",
                        "Nagano-ken",
                        "長野県",
                        "長野"
                    ],
                    "code": "JP-20"
                },
                "Gifu": {
                    "label": "Prefectura de Gifu",
                    "alternate_names": [
                        "Gifu Prefecture",
                        "Gifu-ken",
                        "岐阜県",
                        "岐阜"
                    ],
                    "code": "JP-21"
                },
                "Shizuoka": {
                    "label": "Prefectura de Shizuoka",
                    "alternate_names": [
                        "Shizuoka Prefecture",
                        "Shizuoka-ken",
                        "静岡県",
                        "静岡"
                    ],
                    "code": "JP-22"
                },
                "Aichi": {
                    "label": "Prefectura de Aichi",
                    "alternate_names": [
                        "Aichi Prefecture",
                        "Aichi-ken",
                        "愛知県",
                        "愛知"
                    ],
                    "code": "JP-23"
                },
                "Mie": {
                    "label": "Prefectura de Mie",
                    "alternate_names": [
                        "Mie Prefecture",
                        "Mie-ken",
                        "三重県",
                        "三重"
                    ],
                    "code": "JP-24"
                },
                "Shiga": {
                    "label": "Prefectura de Shiga",
                    "alternate_names": [
                        "Shiga Prefecture",
                        "Shiga-ken",
                        "滋賀県",
                        "滋賀"
                    ],
                    "code": "JP-25"
                },
                "Kyōto": {
                    "label": "Prefectura de Kioto",
                    "alternate_names": [
                        "Kyoto",
                        "Kyoto Prefecture",
                        "Kyōto-fu",
                        "Kyoto-fu",
                        "京都府",
                        "京都"
                    ],
                    "code": "JP-26"
                },
                "Ōsaka": {
                    "label": "Prefectura de Osaka",
                    "alternate_names": [
                        "Osaka",
                        "Osaka Prefecture",
                        "Ōsaka-fu",
                        "Osaka-fu",
                        "大阪府",
                        "大阪"
                    ],
                    "code": "JP-27"
                },
                "Hyōgo": {
                    "label": "Prefectura de Hyōgo",
                    "alternate_names": [
                        "Hyogo",
                        "Hyogo Prefecture",
                        "Hyōgo-ken",
                        "Hyogo-ken",
                        "兵庫県",
                        "兵庫"
                    ],
                    "code": "JP-28"
                },
                "Nara": {
                    "label": "Prefectura de Nara",
                    "alternate_names": [
                        "Nara Prefecture",
                        "Nara-ken",
                        "奈良県",
                        "奈良"
                    ],
                    "code": "JP-29"
                },
                "Wakayama": {
                    "label": "Prefectura de Wakayama",
                    "alternate_names": [
                        "Wakayama Prefecture",
                        "Wakayama-ken",
                        "和歌山県",
                        "和歌山"
                    ],
                    "code": "JP-30"
                },
                "Tottori": {
                    "label": "Prefectura de Tottori",
                    "alternate_names": [
                        "Tottori Prefecture",
                        "Tottori-ken",
                        "鳥取県",
                        "鳥取"
                    ],
                    "code": "JP-31"
                },
                "Shimane": {
                    "label": "Prefectura de Shimane",
                    "alternate_names": [
                        "Shimane Prefecture",
                        "Shimane-ken",
                        "島根県",
                        "島根"
                    ],
                    "code": "JP-32"
                },
                "Okayama": {
                    "label": "Prefectura de Okayama",
                    "alternate_names": [
                        "Okayama Prefecture",
                        "Okayama-ken",
                        "岡山県",
                        "岡山"
                    ],
                    "code": "JP-33"
                },
                "Hiroshima": {
                    "label": "Prefectura de Hiroshima",
                    "alternate_names": [
                        "Hiroshima Prefecture",
                        "Hiroshima-ken",
                        "広島県",
                        "広島"
                    ],
                    "code": "JP-34"
                },
                "Yamaguchi": {
                    "label": "Prefectura de Yamaguchi",
                    "alternate_names": [
                        "Yamaguchi Prefecture",
                        "Yamaguchi-ken",
                        "山口県",
                        "山口"
                    ],
                    "code": "JP-35"
                },
                "Tokushima": {
                    "label": "Prefectura de Tokushima",
                    "alternate_names": [
                        "Tokushima Prefecture",
                        "Tokushima-ken",
                        "徳島県",
                        "徳島"
                    ],
                    "code": "JP-36"
                },
                "Kagawa": {
                    "label": "Prefectura de Kagawa",
                    "alternate_names": [
                        "Kagawa Prefecture",
                        "Kagawa-ken",
                        "香川県",
                        "香川"
                    ],
                    "code": "JP-37"
                },
                "Ehime": {
                    "label": "Prefectura de Ehime",
                    "alternate_names": [
                        "Ehime Prefecture",
                        "Ehime-ken",
                        "愛媛県",
                        "愛媛"
                    ],
                    "code": "JP-38"
                },
                "Kōchi": {
                    "label": "Prefectura de Kōchi",
                    "alternate_names": [
                        "Kochi",
                        "Kochi Prefecture",
                        "Kōchi-ken",
                        "Kochi-ken",
                        "高知県",
                        "高知"
                    ],
                    "code": "JP-39"
                },
                "Fukuoka": {
                    "label": "Prefectura de Fukuoka",
                    "alternate_names": [
                        "Fukuoka Prefecture",
                        "Fukuoka-ken",
                        "福岡県",
                        "福岡"
                    ],
                    "code": "JP-40"
                },
                "Saga": {
                    "label": "Prefectura de Saga",
                    "alternate_names": [
                        "Saga Prefecture",
                        "Saga-ken",
                        "佐賀県",
                        "佐賀"
                    ],
                    "code": "JP-41"
                },
                "Nagasaki": {
                    "label": "Prefectura de Nagasaki",
                    "alternate_names": [
                        "Nagasaki Prefecture",
                        "Nagasaki-ken",
                        "長崎県",
                        "長崎"
                    ],
                    "code": "JP-42"
                },
                "Kumamoto": {
                    "label": "Prefectura de Kumamoto",
                    "alternate_names": [
                        "Kumamoto Prefecture",
                        "Kumamoto-ken",
                        "熊本県",
                        "熊本"
                    ],
                    "code": "JP-43"
                },
                "Ōita": {
                    "label": "Prefectura de Ōita",
                    "alternate_names": [
                        "Oita",
                        "Oita Prefecture",
                        "Ōita-ken",
                        "Oita-ken",
                        "大分県",
                        "大分"
                    ],
                    "code": "JP-44"
                },
                "Miyazaki": {
                    "label": "Prefectura de Miyazaki",
                    "alternate_names": [
                        "Miyazaki Prefecture",
                        "Miyazaki-ken",
                        "宮崎県",
                        "宮崎"
                    ],
                    "code": "JP-45"
                },
                "Kagoshima": {
                    "alternate_names": [
                        "Kagoshima Prefecture",
                        "Kagoshima-ken",
                        "鹿児島県",
                        "鹿児島"
                    ],
                    "code": "JP-46"
                },
                "Okinawa": {
                    "label": "Prefectura de Okinawa",
                    "alternate_names": [
                        "Okinawa Prefecture",
                        "Okinawa-ken",
                        "沖縄県",
                        "沖縄"
                    ],
                    "code": "JP-47"
                }
            }
        }
    ],
    [
        "Jersey",
        {
            "address_format": {
                "edit": 0
            },
            "code": "JE",
            "flag_path": "/assets/flags/je-30b47fc30c7000a133e13893e2395c0ad5d3d8dbee8df0009fcfdcd0018d3e57.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Jordan",
        {
            "address_format": {
                "edit": 0
            },
            "code": "JO",
            "flag_path": "/assets/flags/jo-201aee82186c2cbfb01b982b7eb698eb40b2576fc836b8c893fba1f5bca169fa.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Kazakhstan",
        {
            "address_format": {
                "edit": 0
            },
            "code": "KZ",
            "flag_path": "/assets/flags/kz-fe54c1684b770b07b65593f50aeb7818f11cbdccf0686b86dee4608686e086b5.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Kenya",
        {
            "address_format": {
                "edit": 0
            },
            "code": "KE",
            "flag_path": "/assets/flags/ke-6423e942347b7ebf4cb3da1e4d1ce125b4b2619438f4e60e33182ac52465d161.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Kiribati",
        {
            "address_format": {
                "edit": 0
            },
            "code": "KI",
            "flag_path": "/assets/flags/ki-68a3ecd589d672ca7f080e4b3b42bbc5805b98b2c6222e6054e6d2acdc5ea091.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Korea, Democratic People's Republic Of",
        {
            "address_format": {
                "edit": 0
            },
            "code": "KP",
            "flag_path": "/assets/flags/kp-f19299e65effa61f2a3a16a1eb0adcd9d8182bdee0b0ea5e2904717c4d558f5f.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Kosovo",
        {
            "address_format": {
                "edit": 1
            },
            "code": "XK",
            "flag_path": "/assets/flags/xk-3b76142c4ad51ace803c811af5a9c254c8a28c349766aafed8f2e27b033cc5cd.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Kuwait",
        {
            "address_format": {
                "edit": 6
            },
            "code": "KW",
            "flag_path": "/assets/flags/kw-97c274b4f41d6ec8f3de22ff4ab5f2a20da4a9ac4d0a37101d497495052da643.svg",
            "labels": {
                "province": "Provincia",
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Al Ahmadi": {
                    "label": "Ahmadí",
                    "code": "KW-AH"
                },
                "Al Farwaniyah": {
                    "code": "KW-FA"
                },
                "Al Asimah": {
                    "label": "Capital",
                    "code": "KW-KU"
                },
                "Mubarak Al-Kabeer": {
                    "label": "Gobernación de Mubarak el Grande",
                    "code": "KW-MU"
                },
                "Hawalli": {
                    "code": "KW-HA"
                },
                "Al Jahra": {
                    "label": "Yahra",
                    "code": "KW-JA"
                }
            }
        }
    ],
    [
        "Kyrgyzstan",
        {
            "address_format": {
                "edit": 14
            },
            "code": "KG",
            "flag_path": "/assets/flags/kg-df473c5019959325c8052c3fb1ca898d9970349a0841adf95fd0249e43be637c.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Lao People's Democratic Republic",
        {
            "address_format": {
                "edit": 0
            },
            "code": "LA",
            "flag_path": "/assets/flags/la-4d8b2ffd9f0565f534f6cafb6c389b31d538465ae8fefc72a42797959884b44a.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Latvia",
        {
            "address_format": {
                "edit": 0
            },
            "code": "LV",
            "flag_path": "/assets/flags/lv-dd14a03a93666308fe2b7db49072b31a7da3c195ba9119600dc7eda614b1fe4d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Lebanon",
        {
            "address_format": {
                "edit": 0
            },
            "code": "LB",
            "flag_path": "/assets/flags/lb-258ae2cec2a4ee73dc917b0862b001be8f4ad14a5dce3317bd96d02466751f27.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Lesotho",
        {
            "address_format": {
                "edit": 0
            },
            "code": "LS",
            "flag_path": "/assets/flags/ls-df12a65a810250f636dc54d03efdea2192a28ff2ca28e11029fe520ef892e490.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Liberia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "LR",
            "flag_path": "/assets/flags/lr-0ed46db673754b98e5aaf63cc2905efe4c626fdaa63c90c86d0d3509ac49462e.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Libyan Arab Jamahiriya",
        {
            "address_format": {
                "edit": 0
            },
            "code": "LY",
            "flag_path": "/assets/flags/ly-e63d7aaa0ee51a91c2d345485517dd3b2412baf343390c72a2657f8b45bd46aa.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Liechtenstein",
        {
            "address_format": {
                "edit": 1
            },
            "code": "LI",
            "flag_path": "/assets/flags/li-d4ed2e458fc7ee14a55dd189621692482c856f7d7d2289478d4f259bf1e1e633.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Lithuania",
        {
            "address_format": {
                "edit": 0
            },
            "code": "LT",
            "flag_path": "/assets/flags/lt-9743f780184a60fc75a312b34151ff1a2699e0bf0d456eb91dcbae0472b4d566.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Luxembourg",
        {
            "address_format": {
                "edit": 1
            },
            "code": "LU",
            "flag_path": "/assets/flags/lu-897fc1beb2884b5cf5566a9f8727fe9ea28f95c01bb3aafdad9ae735d2e06541.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Macao",
        {
            "address_format": {
                "edit": 2
            },
            "code": "MO",
            "flag_path": "/assets/flags/mo-8be64db48b5de5274614dede1fa63b8cc279d816b5578bd9cc80f9d7bace28df.svg",
            "labels": {
                "city": "Subdivisión"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Madagascar",
        {
            "address_format": {
                "edit": 1
            },
            "code": "MG",
            "flag_path": "/assets/flags/mg-4027a169d586b91e6a7ff42741884778da3288690ab8477da2785dd7ed262f00.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Malawi",
        {
            "address_format": {
                "edit": 1
            },
            "code": "MW",
            "flag_path": "/assets/flags/mw-2d4f7ad166e7333707c9b14bbe3ddd790e3bd87c5dd477d64e1015dbc95111bf.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Malaysia",
        {
            "address_format": {
                "edit": 3
            },
            "code": "MY",
            "flag_path": "/assets/flags/my-1c099956249bd4c205aed13cfe128eae60c5b0d07df24bb33b36572db43fb57b.svg",
            "labels": {
                "province": "Estado/territorio"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Johor": {
                    "code": "JHR"
                },
                "Kedah": {
                    "code": "KDH"
                },
                "Kelantan": {
                    "code": "KTN"
                },
                "Kuala Lumpur": {
                    "code": "KUL"
                },
                "Labuan": {
                    "code": "LBN"
                },
                "Melaka": {
                    "label": "Malaca",
                    "code": "MLK"
                },
                "Negeri Sembilan": {
                    "code": "NSN"
                },
                "Pahang": {
                    "code": "PHG"
                },
                "Penang": {
                    "alternate_names": [
                        "Pulau Pinang"
                    ],
                    "code": "PNG"
                },
                "Perak": {
                    "code": "PRK"
                },
                "Perlis": {
                    "code": "PLS"
                },
                "Putrajaya": {
                    "code": "PJY"
                },
                "Sabah": {
                    "code": "SBH"
                },
                "Sarawak": {
                    "code": "SWK"
                },
                "Selangor": {
                    "code": "SGR"
                },
                "Terengganu": {
                    "code": "TRG"
                }
            }
        }
    ],
    [
        "Maldives",
        {
            "address_format": {
                "edit": 0
            },
            "code": "MV",
            "flag_path": "/assets/flags/mv-c2d6bb796d0d3ebaa8fc0e94d9553648320ea0748b7ae474f6fa67b0dbdbe754.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Mali",
        {
            "address_format": {
                "edit": 2
            },
            "code": "ML",
            "flag_path": "/assets/flags/ml-ae9516c41b4bb5385e047fc66da8e0e3e3b9360a5850c36d4b5c21950be3853c.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Malta",
        {
            "address_format": {
                "edit": 0
            },
            "code": "MT",
            "flag_path": "/assets/flags/mt-99f935111266ab127e7dce4230fbef035d519d3c90e40997f0132080216efac2.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Martinique",
        {
            "address_format": {
                "edit": 1
            },
            "code": "MQ",
            "flag_path": "/assets/flags/mq-86634673b98e663eff937c29495ffcaceb34e678b1c2cad2e41a1ea5e6157b2d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Mauritania",
        {
            "address_format": {
                "edit": 2
            },
            "code": "MR",
            "flag_path": "/assets/flags/mr-d21a46b9f01e6c81e39b43328f2dd0c7e4077b8d26d3a638da5aa0ace80201c5.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Mauritius",
        {
            "address_format": {
                "edit": 0
            },
            "code": "MU",
            "flag_path": "/assets/flags/mu-c35ef8388abd492cb6ddbb0b46e3be87244ec1088682de208a745c93c4852a80.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Mayotte",
        {
            "address_format": {
                "edit": 1
            },
            "code": "YT",
            "flag_path": "/assets/flags/yt-86634673b98e663eff937c29495ffcaceb34e678b1c2cad2e41a1ea5e6157b2d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Mexico",
        {
            "address_format": {
                "edit": 3
            },
            "code": "MX",
            "flag_path": "/assets/flags/mx-9c6e7f43c522e9b3dc12580407c4ce913b72964f51924c25e886485b5bc6306c.svg",
            "labels": {
                "address1": "Calle y número de casa",
                "province": "Estado"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Aguascalientes": {
                    "code": "AGS"
                },
                "Baja California": {
                    "code": "BC"
                },
                "Baja California Sur": {
                    "code": "BCS"
                },
                "Campeche": {
                    "code": "CAMP"
                },
                "Chiapas": {
                    "code": "CHIS"
                },
                "Chihuahua": {
                    "code": "CHIH"
                },
                "Ciudad de México": {
                    "alternate_names": [
                        "Ciudad de Mexico",
                        "CDMX"
                    ],
                    "code": "DF"
                },
                "Coahuila": {
                    "label": "Coahuila de Zaragoza",
                    "alternate_names": [
                        "Coahuila de Zaragoza"
                    ],
                    "code": "COAH"
                },
                "Colima": {
                    "code": "COL"
                },
                "Durango": {
                    "code": "DGO"
                },
                "Guerrero": {
                    "label": "Estado de Guerrero",
                    "code": "GRO"
                },
                "Hidalgo": {
                    "label": "Estado de Hidalgo",
                    "code": "HGO"
                },
                "México": {
                    "label": "Estado de México",
                    "alternate_names": [
                        "Mexico"
                    ],
                    "code": "MEX"
                },
                "Guanajuato": {
                    "code": "GTO"
                },
                "Jalisco": {
                    "alternate_names": [
                        "Jal."
                    ],
                    "code": "JAL"
                },
                "Michoacán": {
                    "alternate_names": [
                        "Michoacan"
                    ],
                    "code": "MICH"
                },
                "Morelos": {
                    "code": "MOR"
                },
                "Nayarit": {
                    "code": "NAY"
                },
                "Nuevo León": {
                    "alternate_names": [
                        "Nuevo Leon"
                    ],
                    "code": "NL"
                },
                "Oaxaca": {
                    "code": "OAX"
                },
                "Puebla": {
                    "code": "PUE"
                },
                "Querétaro": {
                    "alternate_names": [
                        "Queretaro"
                    ],
                    "code": "QRO"
                },
                "Quintana Roo": {
                    "code": "Q ROO"
                },
                "San Luis Potosí": {
                    "alternate_names": [
                        "San Luis Potosi"
                    ],
                    "code": "SLP"
                },
                "Sinaloa": {
                    "code": "SIN"
                },
                "Sonora": {
                    "code": "SON"
                },
                "Tabasco": {
                    "code": "TAB"
                },
                "Tamaulipas": {
                    "code": "TAMPS"
                },
                "Tlaxcala": {
                    "code": "TLAX"
                },
                "Veracruz": {
                    "code": "VER"
                },
                "Yucatán": {
                    "alternate_names": [
                        "Yucatan"
                    ],
                    "code": "YUC"
                },
                "Zacatecas": {
                    "code": "ZAC"
                }
            }
        }
    ],
    [
        "Moldova, Republic of",
        {
            "address_format": {
                "edit": 1
            },
            "code": "MD",
            "flag_path": "/assets/flags/md-0fe21d795eb6cee3627b2513f84d9e1506fd982695c02e0aafbb2cecb0432e12.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Monaco",
        {
            "address_format": {
                "edit": 1
            },
            "code": "MC",
            "flag_path": "/assets/flags/mc-e9ac42d13744972ba58df4c6df92952cc3245c623385effe3e8ede56e746d2a1.svg",
            "labels": {
                "city": "Municipalidad"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Mongolia",
        {
            "address_format": {
                "edit": 0
            },
            "code": "MN",
            "flag_path": "/assets/flags/mn-c6d9d334a10e75739d2808036632d6d9efaac44dfe8e3af6e7b6d6717a54d31f.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Montenegro",
        {
            "address_format": {
                "edit": 1
            },
            "code": "ME",
            "flag_path": "/assets/flags/me-087ac1f9685fe0510adfd6deedb4e8879f374f20575267990829090f67964827.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Montserrat",
        {
            "address_format": {
                "edit": 0
            },
            "code": "MS",
            "flag_path": "/assets/flags/ms-98d463af5b091e9802076f825cb24412e9277cdf2de1a60b879e55277d9cff06.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Morocco",
        {
            "address_format": {
                "edit": 1
            },
            "code": "MA",
            "flag_path": "/assets/flags/ma-23c18b59cdbd49b7137eecf6b7fbd48bd4d31624b8ca6575fe3a5fd0077e4878.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Mozambique",
        {
            "address_format": {
                "edit": 1
            },
            "code": "MZ",
            "flag_path": "/assets/flags/mz-996ac4f4ee22573acd7d27b859e1ed76466044958cbef04e0f9ef43cdbe24fe5.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Myanmar",
        {
            "address_format": {
                "edit": 0
            },
            "code": "MM",
            "flag_path": "/assets/flags/mm-03265f37d696ff866fe5e2a95fc5e540ac474b880ed33e9a6c914b8986f8151b.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Namibia",
        {
            "address_format": {
                "edit": 0
            },
            "code": "NA",
            "flag_path": "/assets/flags/na-90c32450974e33a4ba44c96ecd1cc57bc121c078a915ea952db501ca26d5b4e3.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Nauru",
        {
            "address_format": {
                "edit": 2
            },
            "code": "NR",
            "flag_path": "/assets/flags/nr-64a5a2bc789d736e2f0cfaca7ca10133942ca7143bcb1e41e45dc5105caa217e.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Nepal",
        {
            "address_format": {
                "edit": 0
            },
            "code": "NP",
            "flag_path": "/assets/flags/np-c88a97b2c8ab2b98b5d58b31d4196d3f4375fb3eee539cdcea2dc084dabdc538.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Netherlands",
        {
            "address_format": {
                "edit": 1
            },
            "code": "NL",
            "flag_path": "/assets/flags/nl-2676c5cacafd969d7d6e4acd949bbd94a0f93d22acea24da776177266b5cd606.svg",
            "labels": {
                "address1": "Calle y número de casa"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Netherlands Antilles",
        {
            "address_format": {
                "edit": 0
            },
            "code": "AN",
            "flag_path": "/assets/flags/an-9227d572c2d4986f23189a2f3a62f72b9a4708ce769a780186455bb3310ebc67.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "New Caledonia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "NC",
            "flag_path": "/assets/flags/nc-52182d447be1d5818a290e06b6d34d3aaf361ba38de78139bb0cc271d0576fae.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "New Zealand",
        {
            "address_format": {
                "edit": 4
            },
            "code": "NZ",
            "flag_path": "/assets/flags/nz-2012c0839ebfb9c15f7e40f065da3350c9203d62cac4708879ef4d4fadd494e8.svg",
            "labels": {
                "address2": "Suburbio (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Bay of Plenty": {
                    "code": "BOP"
                },
                "Canterbury": {
                    "code": "CAN"
                },
                "Gisborne": {
                    "code": "GIS"
                },
                "Hawke's Bay": {
                    "label": "Hawke’s Bay",
                    "code": "HKB"
                },
                "Chatham Islands": {
                    "label": "Islas Chatham",
                    "code": "CIT"
                },
                "Manawatu-Wanganui": {
                    "code": "MWT"
                },
                "Marlborough": {
                    "code": "MBH"
                },
                "Nelson": {
                    "code": "NSN"
                },
                "Northland": {
                    "code": "NTL"
                },
                "Otago": {
                    "code": "OTA"
                },
                "Auckland": {
                    "label": "Región de Auckland",
                    "code": "AUK"
                },
                "Wellington": {
                    "label": "Región de Wellington",
                    "code": "WGN"
                },
                "Southland": {
                    "code": "STL"
                },
                "Taranaki": {
                    "code": "TKI"
                },
                "Tasman": {
                    "code": "TAS"
                },
                "Waikato": {
                    "code": "WKO"
                },
                "West Coast": {
                    "code": "WTC"
                }
            }
        }
    ],
    [
        "Nicaragua",
        {
            "address_format": {
                "edit": 15
            },
            "code": "NI",
            "flag_path": "/assets/flags/ni-5a8a88dc48b5d5254f04d81da95aebaeaeedd52984ba284f41acbda82fca5249.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Niger",
        {
            "address_format": {
                "edit": 1
            },
            "code": "NE",
            "flag_path": "/assets/flags/ne-292cde53b95d01657038037d816778409539e3e3953dec9e6e42e9a9fd12e6dc.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Nigeria",
        {
            "address_format": {
                "edit": 4
            },
            "code": "NG",
            "flag_path": "/assets/flags/ng-dfb8ef54fa8aac6de76c705e2a553d153b9045a19e70f49644803b1458b9e07b.svg",
            "labels": {
                "province": "Estado",
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Abia": {
                    "label": "Abia (estado)",
                    "code": "AB"
                },
                "Adamawa": {
                    "code": "AD"
                },
                "Akwa Ibom": {
                    "code": "AK"
                },
                "Anambra": {
                    "code": "AN"
                },
                "Bauchi": {
                    "code": "BA"
                },
                "Bayelsa": {
                    "code": "BY"
                },
                "Benue": {
                    "code": "BE"
                },
                "Borno": {
                    "code": "BO"
                },
                "Cross River": {
                    "code": "CR"
                },
                "Delta": {
                    "code": "DE"
                },
                "Ebonyi": {
                    "code": "EB"
                },
                "Edo": {
                    "code": "ED"
                },
                "Ekiti": {
                    "code": "EK"
                },
                "Enugu": {
                    "code": "EN"
                },
                "Kano": {
                    "label": "Estado de Kano",
                    "code": "KN"
                },
                "Lagos": {
                    "label": "Estado de Lagos",
                    "code": "LA"
                },
                "Gombe": {
                    "code": "GO"
                },
                "Imo": {
                    "code": "IM"
                },
                "Jigawa": {
                    "code": "JI"
                },
                "Kaduna": {
                    "code": "KD"
                },
                "Katsina": {
                    "code": "KT"
                },
                "Kebbi": {
                    "code": "KE"
                },
                "Kogi": {
                    "code": "KO"
                },
                "Kwara": {
                    "code": "KW"
                },
                "Nasarawa": {
                    "code": "NA"
                },
                "Niger": {
                    "label": "Níger",
                    "code": "NI"
                },
                "Ogun": {
                    "code": "OG"
                },
                "Ondo": {
                    "code": "ON"
                },
                "Osun": {
                    "code": "OS"
                },
                "Oyo": {
                    "code": "OY"
                },
                "Plateau": {
                    "code": "PL"
                },
                "Rivers": {
                    "code": "RI"
                },
                "Sokoto": {
                    "code": "SO"
                },
                "Taraba": {
                    "code": "TA"
                },
                "Abuja Federal Capital Territory": {
                    "label": "Territorio de la Capital Federal",
                    "alternate_names": [
                        "Abuja"
                    ],
                    "code": "FC"
                },
                "Yobe": {
                    "code": "YO"
                },
                "Zamfara": {
                    "code": "ZA"
                }
            }
        }
    ],
    [
        "Niue",
        {
            "address_format": {
                "edit": 2
            },
            "code": "NU",
            "flag_path": "/assets/flags/nu-c3415790973c9d0b828522435a86a6c962231e700bd96d9e18dc28e812ce9146.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Norfolk Island",
        {
            "address_format": {
                "edit": 2
            },
            "code": "NF",
            "flag_path": "/assets/flags/nf-cc6ba9c78b9d755bfc085806b5aa378ca95b055945106f6cc19724a7d85a1cf7.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "North Macedonia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "MK",
            "flag_path": "/assets/flags/mk-97e44eb5f2c87e3f950e06fa8fe2de7bfe90ada6bddb46deb5308a0c1d0cb920.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Norway",
        {
            "address_format": {
                "edit": 1
            },
            "code": "NO",
            "flag_path": "/assets/flags/no-342d1ac081c73a4abb571bf5b9886093ba8ac3d1d81ac834eac7f945c23afd85.svg",
            "labels": {
                "address1": "Calle y número de casa"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Oman",
        {
            "address_format": {
                "edit": 1
            },
            "code": "OM",
            "flag_path": "/assets/flags/om-3b14fd5b81291cf457e4e80f1c9c88f4f0cbdaa6393a07474b6956b6da85e19a.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Pakistan",
        {
            "address_format": {
                "edit": 0
            },
            "code": "PK",
            "flag_path": "/assets/flags/pk-6d929ffd6f700d6674b2861dd6736062f367f35a9ef0443657a442d7a1595eec.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Palestinian Territory, Occupied",
        {
            "address_format": {
                "edit": 0
            },
            "code": "PS",
            "flag_path": "/assets/flags/ps-202a1459d67f30edc5d3d8472eab6bb75c7d30ccb9f52331c2f8f7fd9088805f.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Panama",
        {
            "address_format": {
                "edit": 3
            },
            "code": "PA",
            "flag_path": "/assets/flags/pa-e45de84224b75759dea8e62c6504108e2cdc3546d476c4069c81ddf783208f4d.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Bocas del Toro": {
                    "code": "PA-1"
                },
                "Chiriquí": {
                    "alternate_names": [
                        "Chiriqui"
                    ],
                    "code": "PA-4"
                },
                "Coclé": {
                    "alternate_names": [
                        "Cocle"
                    ],
                    "code": "PA-2"
                },
                "Colón": {
                    "alternate_names": [
                        "Colon"
                    ],
                    "code": "PA-3"
                },
                "Darién": {
                    "alternate_names": [
                        "Darien"
                    ],
                    "code": "PA-5"
                },
                "Emberá": {
                    "label": "Emberá-Wounaan",
                    "alternate_names": [
                        "Embera"
                    ],
                    "code": "PA-EM"
                },
                "Kuna Yala": {
                    "label": "Guna Yala",
                    "code": "PA-KY"
                },
                "Herrera": {
                    "code": "PA-6"
                },
                "Los Santos": {
                    "code": "PA-7"
                },
                "Ngöbe-Buglé": {
                    "label": "Ngäbe-Buglé",
                    "alternate_names": [
                        "Ngobe-Bugle"
                    ],
                    "code": "PA-NB"
                },
                "Panamá": {
                    "alternate_names": [
                        "Panama"
                    ],
                    "code": "PA-8"
                },
                "Panamá Oeste": {
                    "alternate_names": [
                        "Panama Oeste"
                    ],
                    "code": "PA-10"
                },
                "Veraguas": {
                    "code": "PA-9"
                }
            }
        }
    ],
    [
        "Papua New Guinea",
        {
            "address_format": {
                "edit": 0
            },
            "code": "PG",
            "flag_path": "/assets/flags/pg-f2ff8bfc2669433d55b6ce5c9403be983aa9b119f23c92a1a4a8217cab15a6fe.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Paraguay",
        {
            "address_format": {
                "edit": 1
            },
            "code": "PY",
            "flag_path": "/assets/flags/py-f564b33791a5612195cbbb8e58d4d7ba4235cecc9778111404bb3758bd144441.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Peru",
        {
            "address_format": {
                "edit": 4
            },
            "code": "PE",
            "flag_path": "/assets/flags/pe-0885c2bdd8517040143ad92b6f2457804e20223689bb08d6f76b0b1986d2611b.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Amazonas": {
                    "code": "PE-AMA"
                },
                "Áncash": {
                    "alternate_names": [
                        "Ancash",
                        "Ancash"
                    ],
                    "code": "PE-ANC"
                },
                "Apurímac": {
                    "alternate_names": [
                        "Apurimac",
                        "Apurimac"
                    ],
                    "code": "PE-APU"
                },
                "Arequipa": {
                    "code": "PE-ARE"
                },
                "Ayacucho": {
                    "code": "PE-AYA"
                },
                "Cajamarca": {
                    "code": "PE-CAJ"
                },
                "Callao": {
                    "code": "PE-CAL"
                },
                "Cuzco": {
                    "code": "PE-CUS"
                },
                "Huancavelica": {
                    "code": "PE-HUV"
                },
                "Huánuco": {
                    "alternate_names": [
                        "Huanuco",
                        "Huanuco"
                    ],
                    "code": "PE-HUC"
                },
                "Ica": {
                    "code": "PE-ICA"
                },
                "Junín": {
                    "alternate_names": [
                        "Junin",
                        "Junin"
                    ],
                    "code": "PE-JUN"
                },
                "La Libertad": {
                    "code": "PE-LAL"
                },
                "Lambayeque": {
                    "code": "PE-LAM"
                },
                "Lima (departamento)": {
                    "label": "Lima (Departamento)",
                    "code": "PE-LIM"
                },
                "Lima (provincia)": {
                    "label": "Lima (Metropolitana)",
                    "alternate_names": [
                        "Provincia de Lima"
                    ],
                    "code": "PE-LMA"
                },
                "Loreto": {
                    "code": "PE-LOR"
                },
                "Madre de Dios": {
                    "code": "PE-MDD"
                },
                "Moquegua": {
                    "code": "PE-MOQ"
                },
                "Pasco": {
                    "code": "PE-PAS"
                },
                "Piura": {
                    "code": "PE-PIU"
                },
                "Puno": {
                    "code": "PE-PUN"
                },
                "San Martín": {
                    "alternate_names": [
                        "San Martin",
                        "San Martin"
                    ],
                    "code": "PE-SAM"
                },
                "Tacna": {
                    "code": "PE-TAC"
                },
                "Tumbes": {
                    "code": "PE-TUM"
                },
                "Ucayali": {
                    "code": "PE-UCA"
                }
            }
        }
    ],
    [
        "Philippines",
        {
            "address_format": {
                "edit": 6
            },
            "code": "PH",
            "flag_path": "/assets/flags/ph-6b2fbd4feda0c423a0d5ca47e773b40ebbe22ba7f98ea1aea7bc146477badb6f.svg",
            "autocompletion_field": "address1",
            "provinces": {
                "Abra": {
                    "code": "PH-ABR"
                },
                "Agusan del Norte": {
                    "code": "PH-AGN"
                },
                "Agusan del Sur": {
                    "code": "PH-AGS"
                },
                "Aklan": {
                    "code": "PH-AKL"
                },
                "Albay": {
                    "code": "PH-ALB"
                },
                "Antique": {
                    "code": "PH-ANT"
                },
                "Apayao": {
                    "code": "PH-APA"
                },
                "Aurora": {
                    "code": "PH-AUR"
                },
                "Basilan": {
                    "label": "Basilán",
                    "code": "PH-BAS"
                },
                "Bataan": {
                    "label": "Bataán",
                    "code": "PH-BAN"
                },
                "Batanes": {
                    "code": "PH-BTN"
                },
                "Batangas": {
                    "code": "PH-BTG"
                },
                "Benguet": {
                    "code": "PH-BEN"
                },
                "Biliran": {
                    "label": "Bilirán",
                    "code": "PH-BIL"
                },
                "Bohol": {
                    "code": "PH-BOH"
                },
                "Bukidnon": {
                    "code": "PH-BUK"
                },
                "Bulacan": {
                    "label": "Bulacán",
                    "code": "PH-BUL"
                },
                "Cagayan": {
                    "label": "Cagayán",
                    "code": "PH-CAG"
                },
                "Camarines Norte": {
                    "code": "PH-CAN"
                },
                "Camarines Sur": {
                    "code": "PH-CAS"
                },
                "Camiguin": {
                    "label": "Camiguín",
                    "code": "PH-CAM"
                },
                "Capiz": {
                    "label": "Cápiz",
                    "code": "PH-CAP"
                },
                "Catanduanes": {
                    "code": "PH-CAT"
                },
                "Cavite": {
                    "code": "PH-CAV"
                },
                "Cebu": {
                    "label": "Cebú",
                    "code": "PH-CEB"
                },
                "Cotabato": {
                    "code": "PH-NCO"
                },
                "South Cotabato": {
                    "label": "Cotabato del Sur",
                    "code": "PH-SCO"
                },
                "Davao Occidental": {
                    "label": "Dávao Occidental",
                    "code": "PH-DVO"
                },
                "Davao Oriental": {
                    "code": "PH-DAO"
                },
                "Davao del Norte": {
                    "code": "PH-DAV"
                },
                "Davao del Sur": {
                    "code": "PH-DAS"
                },
                "Metro Manila": {
                    "label": "Gran Manila",
                    "code": "PH-00"
                },
                "Guimaras": {
                    "label": "Guimarás",
                    "code": "PH-GUI"
                },
                "Ifugao": {
                    "code": "PH-IFU"
                },
                "Ilocos Norte": {
                    "code": "PH-ILN"
                },
                "Ilocos Sur": {
                    "code": "PH-ILS"
                },
                "Iloilo": {
                    "label": "Iloílo",
                    "code": "PH-ILI"
                },
                "Isabela": {
                    "code": "PH-ISA"
                },
                "Dinagat Islands": {
                    "label": "Islas Dinagat",
                    "code": "PH-DIN"
                },
                "Kalinga": {
                    "code": "PH-KAL"
                },
                "Laguna": {
                    "label": "La Laguna",
                    "code": "PH-LAG"
                },
                "Mountain Province": {
                    "label": "La Montaña",
                    "code": "PH-MOU"
                },
                "La Union": {
                    "label": "La Unión",
                    "code": "PH-LUN"
                },
                "Lanao del Norte": {
                    "code": "PH-LAN"
                },
                "Lanao del Sur": {
                    "code": "PH-LAS"
                },
                "Leyte": {
                    "code": "PH-LEY"
                },
                "Southern Leyte": {
                    "label": "Leyte del Sur",
                    "code": "PH-SLE"
                },
                "Maguindanao": {
                    "code": "PH-MAG"
                },
                "Marinduque": {
                    "code": "PH-MAD"
                },
                "Masbate": {
                    "code": "PH-MAS"
                },
                "Occidental Mindoro": {
                    "label": "Mindoro Occidental",
                    "code": "PH-MDC"
                },
                "Oriental Mindoro": {
                    "label": "Mindoro Oriental",
                    "code": "PH-MDR"
                },
                "Misamis Occidental": {
                    "code": "PH-MSC"
                },
                "Misamis Oriental": {
                    "code": "PH-MSR"
                },
                "Negros Occidental": {
                    "code": "PH-NEC"
                },
                "Negros Oriental": {
                    "code": "PH-NER"
                },
                "Nueva Ecija": {
                    "label": "Nueva Écija",
                    "code": "PH-NUE"
                },
                "Nueva Vizcaya": {
                    "code": "PH-NUV"
                },
                "Palawan": {
                    "code": "PH-PLW"
                },
                "Pampanga": {
                    "code": "PH-PAM"
                },
                "Pangasinan": {
                    "label": "Pangasinán",
                    "code": "PH-PAN"
                },
                "Quezon": {
                    "label": "Quezón",
                    "code": "PH-QUE"
                },
                "Quirino": {
                    "code": "PH-QUI"
                },
                "Rizal": {
                    "code": "PH-RIZ"
                },
                "Romblon": {
                    "label": "Romblón",
                    "code": "PH-ROM"
                },
                "Samar": {
                    "label": "Sámar",
                    "code": "PH-WSA"
                },
                "Eastern Samar": {
                    "label": "Sámar Oriental",
                    "code": "PH-EAS"
                },
                "Northern Samar": {
                    "label": "Sámar del Norte",
                    "code": "PH-NSA"
                },
                "Sarangani": {
                    "code": "PH-SAR"
                },
                "Siquijor": {
                    "code": "PH-SIG"
                },
                "Sorsogon": {
                    "label": "Sorsogón",
                    "code": "PH-SOR"
                },
                "Sultan Kudarat": {
                    "label": "Sultán Kudarat",
                    "code": "PH-SUK"
                },
                "Sulu": {
                    "label": "Sulú",
                    "code": "PH-SLU"
                },
                "Surigao del Norte": {
                    "code": "PH-SUN"
                },
                "Surigao del Sur": {
                    "code": "PH-SUR"
                },
                "Tarlac": {
                    "code": "PH-TAR"
                },
                "Tawi-Tawi": {
                    "code": "PH-TAW"
                },
                "Davao de Oro": {
                    "label": "Valle de Compostela",
                    "code": "PH-COM"
                },
                "Zambales": {
                    "code": "PH-ZMB"
                },
                "Zamboanga Sibugay": {
                    "code": "PH-ZSI"
                },
                "Zamboanga del Norte": {
                    "code": "PH-ZAN"
                },
                "Zamboanga del Sur": {
                    "code": "PH-ZAS"
                }
            }
        }
    ],
    [
        "Pitcairn",
        {
            "address_format": {
                "edit": 9
            },
            "code": "PN",
            "flag_path": "/assets/flags/pn-f270f4504ba91c57fe1144897649f9821157b3c339b5a51354aeb6aca40a7a57.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Poland",
        {
            "address_format": {
                "edit": 1
            },
            "code": "PL",
            "flag_path": "/assets/flags/pl-9fa13a9848a809e00c81f53cc369e878a0f6e212f31f4145a7703d92f6b47a5c.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Portugal",
        {
            "address_format": {
                "edit": 3
            },
            "code": "PT",
            "flag_path": "/assets/flags/pt-2d0ddb5832c38514db4b192272fa1e21999009fd8516eb5dacf1efde01373928.svg",
            "autocompletion_field": "address1",
            "provinces": {
                "Açores": {
                    "label": "Azores",
                    "alternate_names": [
                        "Acores"
                    ],
                    "code": "PT-20"
                },
                "Bragança": {
                    "label": "Braganza",
                    "alternate_names": [
                        "Braganca"
                    ],
                    "code": "PT-04"
                },
                "Aveiro": {
                    "label": "Distrito de Aveiro",
                    "code": "PT-01"
                },
                "Beja": {
                    "label": "Distrito de Beja",
                    "code": "PT-02"
                },
                "Braga": {
                    "label": "Distrito de Braga",
                    "code": "PT-03"
                },
                "Castelo Branco": {
                    "label": "Distrito de Castelo Branco",
                    "code": "PT-05"
                },
                "Coimbra": {
                    "label": "Distrito de Coímbra",
                    "code": "PT-06"
                },
                "Évora": {
                    "label": "Distrito de Évora",
                    "alternate_names": [
                        "Evora"
                    ],
                    "code": "PT-07"
                },
                "Faro": {
                    "label": "Distrito de Faro",
                    "code": "PT-08"
                },
                "Guarda": {
                    "label": "Distrito de Guarda",
                    "code": "PT-09"
                },
                "Leiria": {
                    "label": "Distrito de Leiria",
                    "code": "PT-10"
                },
                "Lisboa": {
                    "label": "Distrito de Lisboa",
                    "code": "PT-11"
                },
                "Porto": {
                    "label": "Distrito de Oporto",
                    "code": "PT-13"
                },
                "Portalegre": {
                    "label": "Distrito de Portalegre",
                    "code": "PT-12"
                },
                "Santarém": {
                    "label": "Distrito de Santarém",
                    "alternate_names": [
                        "Santarem"
                    ],
                    "code": "PT-14"
                },
                "Viana do Castelo": {
                    "label": "Distrito de Viana do Castelo",
                    "code": "PT-16"
                },
                "Vila Real": {
                    "label": "Distrito de Vila Real",
                    "code": "PT-17"
                },
                "Viseu": {
                    "label": "Distrito de Viseu",
                    "code": "PT-18"
                },
                "Madeira": {
                    "code": "PT-30"
                },
                "Setúbal": {
                    "alternate_names": [
                        "Setubal"
                    ],
                    "code": "PT-15"
                }
            }
        }
    ],
    [
        "Qatar",
        {
            "address_format": {
                "edit": 2
            },
            "code": "QA",
            "flag_path": "/assets/flags/qa-dd4dace2ade203b4a9ae2d344b105863004107cc828e609b40a6ae532a74aa03.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Republic of Cameroon",
        {
            "address_format": {
                "edit": 2
            },
            "code": "CM",
            "flag_path": "/assets/flags/cm-70481d263a56361e52399073f5c2c283c72fddcaf723e16339a32067ffd11170.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Reunion",
        {
            "address_format": {
                "edit": 1
            },
            "code": "RE",
            "flag_path": "/assets/flags/re-03d98ae36976f8220ca3de1d406d20f2d33d5fa193ba3a8fbf5f8051d825891d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Romania",
        {
            "address_format": {
                "edit": 3
            },
            "code": "RO",
            "flag_path": "/assets/flags/ro-34dae04dc597e8a7d73ecc92195ec36814a81131823839adf735d7239a4bd0f4.svg",
            "labels": {
                "province": "Condado"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Alba": {
                    "code": "AB"
                },
                "Arad": {
                    "code": "AR"
                },
                "Argeș": {
                    "alternate_names": [
                        "Arge?"
                    ],
                    "code": "AG"
                },
                "Bacău": {
                    "alternate_names": [
                        "Bacau"
                    ],
                    "code": "BC"
                },
                "Bihor": {
                    "code": "BH"
                },
                "Bistrița-Năsăud": {
                    "alternate_names": [
                        "Bistri?a-Nasaud"
                    ],
                    "code": "BN"
                },
                "Botoșani": {
                    "alternate_names": [
                        "Boto?ani"
                    ],
                    "code": "BT"
                },
                "Brăila": {
                    "alternate_names": [
                        "Braila"
                    ],
                    "code": "BR"
                },
                "Brașov": {
                    "alternate_names": [
                        "Bra?ov"
                    ],
                    "code": "BV"
                },
                "București": {
                    "label": "Bucarest",
                    "alternate_names": [
                        "Bucure?ti"
                    ],
                    "code": "B"
                },
                "Buzău": {
                    "alternate_names": [
                        "Buzau"
                    ],
                    "code": "BZ"
                },
                "Caraș-Severin": {
                    "alternate_names": [
                        "Cara?-Severin"
                    ],
                    "code": "CS"
                },
                "Cluj": {
                    "code": "CJ"
                },
                "Constanța": {
                    "alternate_names": [
                        "Constan?a"
                    ],
                    "code": "CT"
                },
                "Covasna": {
                    "code": "CV"
                },
                "Călărași": {
                    "alternate_names": [
                        "Calara?i"
                    ],
                    "code": "CL"
                },
                "Dolj": {
                    "code": "DJ"
                },
                "Dâmbovița": {
                    "alternate_names": [
                        "Dambovi?a"
                    ],
                    "code": "DB"
                },
                "Galați": {
                    "alternate_names": [
                        "Gala?i"
                    ],
                    "code": "GL"
                },
                "Giurgiu": {
                    "code": "GR"
                },
                "Gorj": {
                    "code": "GJ"
                },
                "Harghita": {
                    "code": "HR"
                },
                "Hunedoara": {
                    "code": "HD"
                },
                "Ialomița": {
                    "alternate_names": [
                        "Ialomi?a"
                    ],
                    "code": "IL"
                },
                "Iași": {
                    "alternate_names": [
                        "Ia?i"
                    ],
                    "code": "IS"
                },
                "Ilfov": {
                    "code": "IF"
                },
                "Maramureș": {
                    "alternate_names": [
                        "Maramure?"
                    ],
                    "code": "MM"
                },
                "Mehedinți": {
                    "alternate_names": [
                        "Mehedin?i"
                    ],
                    "code": "MH"
                },
                "Mureș": {
                    "alternate_names": [
                        "Mure?"
                    ],
                    "code": "MS"
                },
                "Neamț": {
                    "alternate_names": [
                        "Neam?"
                    ],
                    "code": "NT"
                },
                "Olt": {
                    "code": "OT"
                },
                "Prahova": {
                    "code": "PH"
                },
                "Sălaj": {
                    "alternate_names": [
                        "Salaj"
                    ],
                    "code": "SJ"
                },
                "Satu Mare": {
                    "code": "SM"
                },
                "Sibiu": {
                    "code": "SB"
                },
                "Suceava": {
                    "code": "SV"
                },
                "Teleorman": {
                    "code": "TR"
                },
                "Timiș": {
                    "alternate_names": [
                        "Timi?"
                    ],
                    "code": "TM"
                },
                "Tulcea": {
                    "code": "TL"
                },
                "Vâlcea": {
                    "alternate_names": [
                        "Valcea"
                    ],
                    "code": "VL"
                },
                "Vaslui": {
                    "code": "VS"
                },
                "Vrancea": {
                    "code": "VN"
                }
            }
        }
    ],
    [
        "Russia",
        {
            "address_format": {
                "edit": 4
            },
            "code": "RU",
            "flag_path": "/assets/flags/ru-7873536dbf4318bcbdb910bb9780a4674de952fd8e87d7f9a21cd50e321c08c8.svg",
            "autocompletion_field": "address1",
            "provinces": {
                "Republic of Adygeya": {
                    "label": "Adigueya",
                    "code": "AD"
                },
                "Altai Republic": {
                    "label": "Altái",
                    "code": "AL"
                },
                "Amur Oblast": {
                    "label": "Amur",
                    "code": "AMU"
                },
                "Astrakhan Oblast": {
                    "label": "Astracán",
                    "code": "AST"
                },
                "Republic of Bashkortostan": {
                    "label": "Bashkortostán",
                    "code": "BA"
                },
                "Republic of Buryatia": {
                    "label": "Buriatia",
                    "code": "BU"
                },
                "Chechen Republic": {
                    "label": "Chechenia",
                    "code": "CE"
                },
                "Chelyabinsk Oblast": {
                    "label": "Cheliábinsk",
                    "code": "CHE"
                },
                "Chukotka Autonomous Okrug": {
                    "label": "Chukotka",
                    "code": "CHU"
                },
                "Chuvash Republic": {
                    "label": "Chuvasia",
                    "code": "CU"
                },
                "Republic of Dagestan": {
                    "label": "Daguestán",
                    "code": "DA"
                },
                "Republic of Ingushetia": {
                    "label": "Ingusetia",
                    "code": "IN"
                },
                "Irkutsk Oblast": {
                    "label": "Irkutsk",
                    "code": "IRK"
                },
                "Khabarovsk Krai": {
                    "label": "Jabárovsk",
                    "code": "KHA"
                },
                "Republic of Khakassia": {
                    "label": "Jakasia",
                    "code": "KK"
                },
                "Khanty-Mansi Autonomous Okrug": {
                    "label": "Janti-Mansi",
                    "code": "KHM"
                },
                "Kabardino-Balkarian Republic": {
                    "label": "Kabardia-Balkaria",
                    "code": "KB"
                },
                "Republic of Kalmykia": {
                    "label": "Kalmukia",
                    "code": "KL"
                },
                "Kaluga Oblast": {
                    "label": "Kaluga",
                    "code": "KLU"
                },
                "Kamchatka Krai": {
                    "label": "Kamchatka",
                    "code": "KAM"
                },
                "Karachay–Cherkess Republic": {
                    "label": "Karacháyevo-Cherkesia",
                    "alternate_names": [
                        "Karachay?Cherkess Republic"
                    ],
                    "code": "KC"
                },
                "Kemerovo Oblast": {
                    "label": "Kémerovo",
                    "code": "KEM"
                },
                "Kirov Oblast": {
                    "label": "Kírov",
                    "code": "KIR"
                },
                "Komi Republic": {
                    "label": "Komi",
                    "code": "KO"
                },
                "Altai Krai": {
                    "label": "Krai de Altái",
                    "code": "ALT"
                },
                "Krasnodar Krai": {
                    "label": "Krai de Krasnodar",
                    "code": "KDA"
                },
                "Krasnoyarsk Krai": {
                    "label": "Krasnoyarsk",
                    "code": "KYA"
                },
                "Kurgan Oblast": {
                    "label": "Kurgán",
                    "code": "KGN"
                },
                "Magadan Oblast": {
                    "label": "Magadán",
                    "code": "MAG"
                },
                "Mari El Republic": {
                    "label": "Mari-El",
                    "code": "ME"
                },
                "Republic of Mordovia": {
                    "label": "Mordovia",
                    "code": "MO"
                },
                "Moscow": {
                    "label": "Moscú",
                    "code": "MOW"
                },
                "Novosibirsk Oblast": {
                    "label": "Novosibirsk",
                    "code": "NVS"
                },
                "Jewish Autonomous Oblast": {
                    "label": "Óblast Autónomo Hebreo",
                    "code": "YEV"
                },
                "Arkhangelsk Oblast": {
                    "label": "Óblast de Arjánguelsk",
                    "code": "ARK"
                },
                "Belgorod Oblast": {
                    "label": "Óblast de Bélgorod",
                    "code": "BEL"
                },
                "Bryansk Oblast": {
                    "label": "Óblast de Briansk",
                    "code": "BRY"
                },
                "Ivanovo Oblast": {
                    "label": "Óblast de Ivánovo",
                    "code": "IVA"
                },
                "Kaliningrad Oblast": {
                    "label": "Óblast de Kaliningrado",
                    "code": "KGD"
                },
                "Kostroma Oblast": {
                    "label": "Óblast de Kostromá",
                    "code": "KOS"
                },
                "Kursk Oblast": {
                    "label": "Óblast de Kursk",
                    "code": "KRS"
                },
                "Leningrad Oblast": {
                    "label": "Óblast de Leningrado",
                    "code": "LEN"
                },
                "Lipetsk Oblast": {
                    "label": "Óblast de Lípetsk",
                    "code": "LIP"
                },
                "Moscow Oblast": {
                    "label": "Óblast de Moscú",
                    "code": "MOS"
                },
                "Murmansk Oblast": {
                    "label": "Óblast de Múrmansk",
                    "code": "MUR"
                },
                "Nizhny Novgorod Oblast": {
                    "label": "Óblast de Nizhni Nóvgorod",
                    "code": "NIZ"
                },
                "Novgorod Oblast": {
                    "label": "Óblast de Nóvgorod",
                    "code": "NGR"
                },
                "Orenburg Oblast": {
                    "label": "Óblast de Oremburgo",
                    "code": "ORE"
                },
                "Penza Oblast": {
                    "label": "Óblast de Penza",
                    "code": "PNZ"
                },
                "Pskov Oblast": {
                    "label": "Óblast de Pskov",
                    "code": "PSK"
                },
                "Ryazan Oblast": {
                    "label": "Óblast de Riazán",
                    "code": "RYA"
                },
                "Samara Oblast": {
                    "label": "Óblast de Samara",
                    "code": "SAM"
                },
                "Saratov Oblast": {
                    "label": "Óblast de Sarátov",
                    "code": "SAR"
                },
                "Tula Oblast": {
                    "label": "Óblast de Tula",
                    "code": "TUL"
                },
                "Tver Oblast": {
                    "label": "Óblast de Tver",
                    "code": "TVE"
                },
                "Vladimir Oblast": {
                    "label": "Óblast de Vladímir",
                    "code": "VLA"
                },
                "Vologda Oblast": {
                    "label": "Óblast de Vólogda",
                    "code": "VLG"
                },
                "Voronezh Oblast": {
                    "label": "Óblast de Vorónezh",
                    "code": "VOR"
                },
                "Yaroslavl Oblast": {
                    "label": "Óblast de Yaroslavl",
                    "code": "YAR"
                },
                "Omsk Oblast": {
                    "label": "Omsk",
                    "code": "OMS"
                },
                "Oryol Oblast": {
                    "label": "Oriol",
                    "code": "ORL"
                },
                "Republic of North Ossetia–Alania": {
                    "label": "Osetia del Norte - Alania",
                    "alternate_names": [
                        "Republic of North Ossetia?Alania"
                    ],
                    "code": "SE"
                },
                "Perm Krai": {
                    "label": "Perm",
                    "code": "PER"
                },
                "Primorsky Krai": {
                    "label": "Primorie",
                    "code": "PRI"
                },
                "Republic of Karelia": {
                    "label": "República de Carelia",
                    "code": "KR"
                },
                "Rostov Oblast": {
                    "label": "Rostov",
                    "code": "ROS"
                },
                "Sakha Republic (Yakutia)": {
                    "label": "Sajá",
                    "code": "SA"
                },
                "Sakhalin Oblast": {
                    "label": "Sajalín",
                    "code": "SAK"
                },
                "Saint Petersburg": {
                    "label": "San Petersburgo",
                    "code": "SPE"
                },
                "Smolensk Oblast": {
                    "label": "Smolensk",
                    "code": "SMO"
                },
                "Stavropol Krai": {
                    "label": "Stávropol",
                    "code": "STA"
                },
                "Sverdlovsk Oblast": {
                    "label": "Sverdlovsk",
                    "code": "SVE"
                },
                "Tambov Oblast": {
                    "label": "Tambov",
                    "code": "TAM"
                },
                "Republic of Tatarstan": {
                    "label": "Tartaristán",
                    "code": "TA"
                },
                "Tyumen Oblast": {
                    "label": "Tiumén",
                    "code": "TYU"
                },
                "Tomsk Oblast": {
                    "label": "Tomsk",
                    "code": "TOM"
                },
                "Tyva Republic": {
                    "label": "Tuvá",
                    "code": "TY"
                },
                "Udmurtia": {
                    "code": "UD"
                },
                "Ulyanovsk Oblast": {
                    "label": "Uliánovsk",
                    "code": "ULY"
                },
                "Volgograd Oblast": {
                    "label": "Volgogrado",
                    "code": "VGG"
                },
                "Yamalo-Nenets Autonomous Okrug": {
                    "label": "Yamalia-Nenetsia",
                    "code": "YAN"
                },
                "Zabaykalsky Krai": {
                    "label": "Zabaikalie",
                    "code": "ZAB"
                }
            }
        }
    ],
    [
        "Rwanda",
        {
            "address_format": {
                "edit": 2
            },
            "code": "RW",
            "flag_path": "/assets/flags/rw-e7f1e954486b796027484aa0aeb541fe84ed538c08d45aa8474962979b93be60.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Saint Barthélemy",
        {
            "address_format": {
                "edit": 1
            },
            "code": "BL",
            "flag_path": "/assets/flags/bl-86634673b98e663eff937c29495ffcaceb34e678b1c2cad2e41a1ea5e6157b2d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Saint Helena",
        {
            "address_format": {
                "edit": 2
            },
            "code": "SH",
            "flag_path": "/assets/flags/sh-6bf210ff42d01094ddd26b9c6335bccf5aa368ac6e56419dce3f6906e99331e0.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Saint Kitts And Nevis",
        {
            "address_format": {
                "edit": 0
            },
            "code": "KN",
            "flag_path": "/assets/flags/kn-79a83d6e2c6cb38a6c70ab722f00aa5f0fa91a961ffbb95ceb0f128c0cc28e98.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Saint Lucia",
        {
            "address_format": {
                "edit": 0
            },
            "code": "LC",
            "flag_path": "/assets/flags/lc-e19adada543974e4fff0d83051118572859fe421a07960b2865126458c5958d6.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Saint Martin",
        {
            "address_format": {
                "edit": 1
            },
            "code": "MF",
            "flag_path": "/assets/flags/mf-86634673b98e663eff937c29495ffcaceb34e678b1c2cad2e41a1ea5e6157b2d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Saint Pierre And Miquelon",
        {
            "address_format": {
                "edit": 1
            },
            "code": "PM",
            "flag_path": "/assets/flags/pm-2c29c0bcb7ff14822475d54b3642feb1705f9635e12e1987897434941acda410.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Samoa",
        {
            "address_format": {
                "edit": 0
            },
            "code": "WS",
            "flag_path": "/assets/flags/ws-101a31cc95dbad1540663deed9856bc3d612a82115beccaa34124470e1e2392a.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "San Marino",
        {
            "address_format": {
                "edit": 1
            },
            "code": "SM",
            "flag_path": "/assets/flags/sm-d02aac897964dd337cb56a1ad0e6c9989d07ed80de3d01ef8cf31f21a79163c3.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Sao Tome And Principe",
        {
            "address_format": {
                "edit": 2
            },
            "code": "ST",
            "flag_path": "/assets/flags/st-007d5f0c99ebd05360f8d63c5406d4381433b1db3d526c8b18dd95a04159b3c9.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Saudi Arabia",
        {
            "address_format": {
                "edit": 0
            },
            "code": "SA",
            "flag_path": "/assets/flags/sa-38a6b09d4d67fc643a8befe04e0e076fc9ed72f575fc56c65da02aa33b77adda.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Senegal",
        {
            "address_format": {
                "edit": 1
            },
            "code": "SN",
            "flag_path": "/assets/flags/sn-c1bda95ee1d9a1314dbf36ed8ea3c835758601a2f426d32de12dbc56fe0f7ef0.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Serbia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "RS",
            "flag_path": "/assets/flags/rs-ad55de6fb8ecf8d02afb5aefa63b0ffca0b646b1bee8fc53cfcbe54cd509ca3f.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Seychelles",
        {
            "address_format": {
                "edit": 2
            },
            "code": "SC",
            "flag_path": "/assets/flags/sc-85350c02432a77c207622ff0e7c4a1ac44c19a74039ffb589d21119214039f05.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Sierra Leone",
        {
            "address_format": {
                "edit": 2
            },
            "code": "SL",
            "flag_path": "/assets/flags/sl-21d7e0663d2b8e1d455a0e1456c63dfbb273becdacbf7c1fa0e22d915f136cf4.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Singapore",
        {
            "address_format": {
                "edit": 16
            },
            "code": "SG",
            "flag_path": "/assets/flags/sg-90a21a7a0bfd78fe5b15351818fa4e91b344d5d320d4c60ca595f881fae2d82f.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Sint Maarten",
        {
            "address_format": {
                "edit": 2
            },
            "code": "SX",
            "flag_path": "/assets/flags/sx-5edee2ee334fd509959886be924d1897c7a6a5a1179a7f1352018e9dfc63f0a7.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Slovakia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "SK",
            "flag_path": "/assets/flags/sk-13bef619a39bab1000cd7c39e61ef3b442116fa473a8b86de6ed051ba5e98806.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Slovenia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "SI",
            "flag_path": "/assets/flags/si-214adb14209d7e4845e6ad67c9af2fb3ca7ab5ef8c836f67b95c72fd1d2ae1f0.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Solomon Islands",
        {
            "address_format": {
                "edit": 2
            },
            "code": "SB",
            "flag_path": "/assets/flags/sb-2ea13ff2fca5e30c6f9f06298f779e5e9adca9402c59498e3896760c1805467e.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Somalia",
        {
            "address_format": {
                "edit": 0
            },
            "code": "SO",
            "flag_path": "/assets/flags/so-e90f2ba05f08855782692f953c3c4df55012e1f89743e8f1ad2f51bf4631e93c.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "South Africa",
        {
            "address_format": {
                "edit": 4
            },
            "code": "ZA",
            "flag_path": "/assets/flags/za-7381220c0ff6cec6ef48004e256a583d0da9c17be943c195a7a92ee9bd5728d3.svg",
            "labels": {
                "province": "Provincia",
                "address2": "Suburbio (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Gauteng": {
                    "code": "GP"
                },
                "KwaZulu-Natal": {
                    "code": "NL"
                },
                "Mpumalanga": {
                    "code": "MP"
                },
                "Western Cape": {
                    "label": "Provincia Occidental del Cabo",
                    "code": "WC"
                },
                "Eastern Cape": {
                    "label": "Provincia Oriental del Cabo",
                    "code": "EC"
                },
                "Northern Cape": {
                    "label": "Provincia Septentrional del Cabo",
                    "code": "NC"
                },
                "Limpopo": {
                    "label": "Provincia de Limpopo",
                    "code": "LP"
                },
                "Free State": {
                    "label": "Provincia del Estado Libre",
                    "code": "FS"
                },
                "North West": {
                    "label": "Provincia del Noroeste",
                    "code": "NW"
                }
            }
        }
    ],
    [
        "South Georgia And The South Sandwich Islands",
        {
            "address_format": {
                "edit": 9
            },
            "code": "GS",
            "flag_path": "/assets/flags/gs-a33151c39353c464133d1b726f2af515dfc455b88fa5667a2d3c14af75354423.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "South Korea",
        {
            "address_format": {
                "edit": 17
            },
            "code": "KR",
            "flag_path": "/assets/flags/kr-259689b1cef138632a2158aaf7d77a64695f7370137b4311e6d0a90d189f86b2.svg",
            "labels": {
                "province": "Provincia"
            },
            "autocompletion_field": "zip",
            "provinces": {
                "Busan": {
                    "code": "KR-26"
                },
                "Chungbuk": {
                    "label": "Chungcheong del Norte",
                    "code": "KR-43"
                },
                "Chungnam": {
                    "label": "Chungcheong del Sur",
                    "code": "KR-44"
                },
                "Daegu": {
                    "code": "KR-27"
                },
                "Daejeon": {
                    "code": "KR-30"
                },
                "Gangwon": {
                    "code": "KR-42"
                },
                "Gwangju": {
                    "code": "KR-29"
                },
                "Gyeonggi": {
                    "code": "KR-41"
                },
                "Gyeongbuk": {
                    "label": "Gyeongsang del Norte",
                    "code": "KR-47"
                },
                "Gyeongnam": {
                    "label": "Gyeongsang del Sur",
                    "code": "KR-48"
                },
                "Incheon": {
                    "code": "KR-28"
                },
                "Jeju": {
                    "label": "Jeju-do",
                    "code": "KR-49"
                },
                "Jeonbuk": {
                    "label": "Jeolla del Norte",
                    "code": "KR-45"
                },
                "Jeonnam": {
                    "label": "Jeolla del Sur",
                    "code": "KR-46"
                },
                "Sejong": {
                    "code": "KR-50"
                },
                "Seoul": {
                    "label": "Seúl",
                    "code": "KR-11"
                },
                "Ulsan": {
                    "code": "KR-31"
                }
            }
        }
    ],
    [
        "South Sudan",
        {
            "address_format": {
                "edit": 2
            },
            "code": "SS",
            "flag_path": "/assets/flags/ss-42d9c46c76ac9f0c718ef08c8c17fc85f35d053737217485add011acbb5a9129.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Spain",
        {
            "address_format": {
                "edit": 3
            },
            "code": "ES",
            "flag_path": "/assets/flags/es-3039156bd5026cf6bc928ff1708fa97506c4f19ba4f7be3f2d25fe6118805ed6.svg",
            "labels": {
                "address1": "Calle y número de casa",
                "province": "Provincia"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Álava": {
                    "alternate_names": [
                        "Alava",
                        "Araba"
                    ],
                    "code": "VI"
                },
                "Albacete": {
                    "code": "AB"
                },
                "Alicante": {
                    "code": "A"
                },
                "Almería": {
                    "alternate_names": [
                        "Almeria"
                    ],
                    "code": "AL"
                },
                "Asturias": {
                    "alternate_names": [
                        "Principado de Asturias"
                    ],
                    "code": "O"
                },
                "Ávila": {
                    "alternate_names": [
                        "Avila"
                    ],
                    "code": "AV"
                },
                "Badajoz": {
                    "code": "BA"
                },
                "Barcelona": {
                    "code": "B"
                },
                "Burgos": {
                    "code": "BU"
                },
                "Cáceres": {
                    "alternate_names": [
                        "Caceres"
                    ],
                    "code": "CC"
                },
                "Cádiz": {
                    "alternate_names": [
                        "Cadiz"
                    ],
                    "code": "CA"
                },
                "Cantabria": {
                    "code": "S"
                },
                "Castellón": {
                    "alternate_names": [
                        "Castellon",
                        "Castelló",
                        "Castello"
                    ],
                    "code": "CS"
                },
                "Ceuta": {
                    "code": "CE"
                },
                "Ciudad Real": {
                    "alternate_names": [
                        "Cdad. Real"
                    ],
                    "code": "CR"
                },
                "Córdoba": {
                    "alternate_names": [
                        "Cordoba",
                        "Cordova"
                    ],
                    "code": "CO"
                },
                "Cuenca": {
                    "code": "CU"
                },
                "Girona": {
                    "label": "Gerona",
                    "alternate_names": [
                        "Gerona"
                    ],
                    "code": "GI"
                },
                "Granada": {
                    "code": "GR"
                },
                "Guadalajara": {
                    "code": "GU"
                },
                "Guipúzcoa": {
                    "alternate_names": [
                        "Guipuzcoa",
                        "Gipuzkoa"
                    ],
                    "code": "SS"
                },
                "Huelva": {
                    "code": "H"
                },
                "Huesca": {
                    "alternate_names": [
                        "Uesca",
                        "Osca"
                    ],
                    "code": "HU"
                },
                "Balears": {
                    "label": "Islas Baleares",
                    "alternate_names": [
                        "Baleares",
                        "Illes Balears",
                        "Islas Baleares"
                    ],
                    "code": "PM"
                },
                "Jaén": {
                    "alternate_names": [
                        "Jaen"
                    ],
                    "code": "J"
                },
                "A Coruña": {
                    "label": "La Coruña",
                    "alternate_names": [
                        "A Coruna"
                    ],
                    "code": "C"
                },
                "La Rioja": {
                    "code": "LO"
                },
                "Las Palmas": {
                    "code": "GC"
                },
                "León": {
                    "alternate_names": [
                        "Leon"
                    ],
                    "code": "LE"
                },
                "Lleida": {
                    "label": "Lérida",
                    "alternate_names": [
                        "Lérida",
                        "Lerida"
                    ],
                    "code": "L"
                },
                "Lugo": {
                    "code": "LU"
                },
                "Madrid": {
                    "alternate_names": [
                        "Comunidad de Madrid",
                        "Community of Madrid"
                    ],
                    "code": "M"
                },
                "Málaga": {
                    "alternate_names": [
                        "Malaga"
                    ],
                    "code": "MA"
                },
                "Melilla": {
                    "code": "ML"
                },
                "Murcia": {
                    "alternate_names": [
                        "Región de Murcia",
                        "Region de Murcia"
                    ],
                    "code": "MU"
                },
                "Navarra": {
                    "alternate_names": [
                        "Nafarroa",
                        "Navarre"
                    ],
                    "code": "NA"
                },
                "Ourense": {
                    "label": "Orense",
                    "code": "OR"
                },
                "Palencia": {
                    "code": "P"
                },
                "Pontevedra": {
                    "code": "PO"
                },
                "Salamanca": {
                    "code": "SA"
                },
                "Santa Cruz de Tenerife": {
                    "alternate_names": [
                        "Santa Cruz"
                    ],
                    "code": "TF"
                },
                "Segovia": {
                    "code": "SG"
                },
                "Sevilla": {
                    "alternate_names": [
                        "Seville"
                    ],
                    "code": "SE"
                },
                "Soria": {
                    "code": "SO"
                },
                "Tarragona": {
                    "code": "T"
                },
                "Teruel": {
                    "code": "TE"
                },
                "Toledo": {
                    "code": "TO"
                },
                "Valencia": {
                    "alternate_names": [
                        "València"
                    ],
                    "code": "V"
                },
                "Valladolid": {
                    "code": "VA"
                },
                "Vizcaya": {
                    "alternate_names": [
                        "Biscay",
                        "Bizkaia"
                    ],
                    "code": "BI"
                },
                "Zamora": {
                    "code": "ZA"
                },
                "Zaragoza": {
                    "alternate_names": [
                        "Saragossa"
                    ],
                    "code": "Z"
                }
            }
        }
    ],
    [
        "Sri Lanka",
        {
            "address_format": {
                "edit": 0
            },
            "code": "LK",
            "flag_path": "/assets/flags/lk-fadc6f5b73b8dca1e70961a2a83f975205e842b3dbc2a36ba22020e61d154410.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "St. Vincent",
        {
            "address_format": {
                "edit": 0
            },
            "code": "VC",
            "flag_path": "/assets/flags/vc-85087234a61540fc2fd046f64c194c10369429b9b16df6dc11d3f219f602619d.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Sudan",
        {
            "address_format": {
                "edit": 1
            },
            "code": "SD",
            "flag_path": "/assets/flags/sd-1f7504f8d4b352eb1726d81a563212c650a8d316d67c97c6167b96895ffa703d.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Suriname",
        {
            "address_format": {
                "edit": 2
            },
            "code": "SR",
            "flag_path": "/assets/flags/sr-78ec43e380ca2dfc631f0fe7142c806e05fcebfdeb096ef8e5defa48c38017a1.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Svalbard And Jan Mayen",
        {
            "address_format": {
                "edit": 1
            },
            "code": "SJ",
            "flag_path": "/assets/flags/sj-342d1ac081c73a4abb571bf5b9886093ba8ac3d1d81ac834eac7f945c23afd85.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Sweden",
        {
            "address_format": {
                "edit": 1
            },
            "code": "SE",
            "flag_path": "/assets/flags/se-03f83fa2812a176c6392442ce1c3582958e667579ffb4e21a55a2110107a068a.svg",
            "labels": {
                "address1": "Calle y número de casa",
                "city": "Ciudad/pueblo",
                "address2": "Apartamento, local, etc. (oppcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Switzerland",
        {
            "address_format": {
                "edit": 1
            },
            "code": "CH",
            "flag_path": "/assets/flags/ch-c9bc2a15cb055b4eaf60fa6c8fce64b3a98b09dcd6fd81f64712404013dc08c7.svg",
            "labels": {
                "address1": "Calle y número de casa",
                "address2": "Dirección adicional (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Syria",
        {
            "address_format": {
                "edit": 0
            },
            "code": "SY",
            "flag_path": "/assets/flags/sy-5b83160707bc19b2371c6c09537531bff976acf890315a1ca3fa8f386a63bf2f.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Taiwan",
        {
            "address_format": {
                "edit": 0
            },
            "code": "TW",
            "flag_path": "/assets/flags/tw-5746f661cc72b6ad258fc7ac51c75e483eeadd44e436fa10fbec8bfe6ea5fe5c.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Tajikistan",
        {
            "address_format": {
                "edit": 1
            },
            "code": "TJ",
            "flag_path": "/assets/flags/tj-dd744d72f1424c6cc7016739ffd3f082dc54762eb1c7afece6339816dff79824.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Tanzania, United Republic Of",
        {
            "address_format": {
                "edit": 1
            },
            "code": "TZ",
            "flag_path": "/assets/flags/tz-4de9d3102e57f0f59eefcf7c41797a153b437a65760434213bd742855c98014a.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Thailand",
        {
            "address_format": {
                "edit": 4
            },
            "code": "TH",
            "flag_path": "/assets/flags/th-3ba34d06c2ffb766606c8f04d222a847b916384ecf883cf1f3e77ca72313a933.svg",
            "labels": {
                "province": "Provincia"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Bangkok": {
                    "alternate_names": [
                        "Krung Thep Maha Nakhon"
                    ],
                    "code": "TH-10"
                },
                "Bueng Kan": {
                    "code": "TH-38"
                },
                "Mukdahan": {
                    "code": "TH-49"
                },
                "Nakhon Pathom": {
                    "code": "TH-73"
                },
                "Nong Bua Lam Phu": {
                    "label": "Nongbua Lamphu",
                    "code": "TH-39"
                },
                "Pattaya": {
                    "code": "TH-S"
                },
                "Amnat Charoen": {
                    "label": "Provincia de Amnat Charoen",
                    "code": "TH-37"
                },
                "Ang Thong": {
                    "label": "Provincia de Ang Thong",
                    "code": "TH-15"
                },
                "Buriram": {
                    "label": "Provincia de Buri Ram",
                    "alternate_names": [
                        "Buri Ram"
                    ],
                    "code": "TH-31"
                },
                "Chachoengsao": {
                    "label": "Provincia de Chachoengsao",
                    "code": "TH-24"
                },
                "Chai Nat": {
                    "label": "Provincia de Chainat",
                    "code": "TH-18"
                },
                "Chaiyaphum": {
                    "label": "Provincia de Chaiyaphum",
                    "code": "TH-36"
                },
                "Chanthaburi": {
                    "label": "Provincia de Chanthaburi",
                    "code": "TH-22"
                },
                "Chiang Mai": {
                    "label": "Provincia de Chiang Mai",
                    "code": "TH-50"
                },
                "Chiang Rai": {
                    "label": "Provincia de Chiang Rai",
                    "code": "TH-57"
                },
                "Chon Buri": {
                    "label": "Provincia de Chon Buri",
                    "code": "TH-20"
                },
                "Chumphon": {
                    "label": "Provincia de Chumphon",
                    "code": "TH-86"
                },
                "Kalasin": {
                    "label": "Provincia de Kalasin",
                    "code": "TH-46"
                },
                "Kamphaeng Phet": {
                    "label": "Provincia de Kamphaeng Phet",
                    "code": "TH-62"
                },
                "Kanchanaburi": {
                    "label": "Provincia de Kanchanaburi",
                    "code": "TH-71"
                },
                "Khon Kaen": {
                    "label": "Provincia de Khon Kaen",
                    "code": "TH-40"
                },
                "Krabi": {
                    "label": "Provincia de Krabi",
                    "code": "TH-81"
                },
                "Lampang": {
                    "label": "Provincia de Lampang",
                    "code": "TH-52"
                },
                "Lamphun": {
                    "label": "Provincia de Lamphun",
                    "code": "TH-51"
                },
                "Loei": {
                    "label": "Provincia de Loei",
                    "code": "TH-42"
                },
                "Lopburi": {
                    "label": "Provincia de Lopburi",
                    "alternate_names": [
                        "Lop Buri"
                    ],
                    "code": "TH-16"
                },
                "Mae Hong Son": {
                    "label": "Provincia de Mae Hong Son",
                    "code": "TH-58"
                },
                "Maha Sarakham": {
                    "label": "Provincia de Maha Sarakham",
                    "code": "TH-44"
                },
                "Nakhon Nayok": {
                    "label": "Provincia de Nakhon Nayok",
                    "code": "TH-26"
                },
                "Nakhon Phanom": {
                    "label": "Provincia de Nakhon Phanom",
                    "code": "TH-48"
                },
                "Nakhon Ratchasima": {
                    "label": "Provincia de Nakhon Ratchasima",
                    "code": "TH-30"
                },
                "Nakhon Sawan": {
                    "label": "Provincia de Nakhon Sawan",
                    "code": "TH-60"
                },
                "Nakhon Si Thammarat": {
                    "label": "Provincia de Nakhon Si Thammarat",
                    "code": "TH-80"
                },
                "Nan": {
                    "label": "Provincia de Nan",
                    "code": "TH-55"
                },
                "Narathiwat": {
                    "label": "Provincia de Narathiwat",
                    "code": "TH-96"
                },
                "Nong Khai": {
                    "label": "Provincia de Nong Khai",
                    "code": "TH-43"
                },
                "Nonthaburi": {
                    "label": "Provincia de Nonthaburi",
                    "code": "TH-12"
                },
                "Pathum Thani": {
                    "label": "Provincia de Pathum Thani",
                    "code": "TH-13"
                },
                "Pattani": {
                    "label": "Provincia de Pattani",
                    "code": "TH-94"
                },
                "Phangnga": {
                    "label": "Provincia de Phang Nga",
                    "code": "TH-82"
                },
                "Phatthalung": {
                    "label": "Provincia de Phatthalung",
                    "code": "TH-93"
                },
                "Phayao": {
                    "label": "Provincia de Phayao",
                    "code": "TH-56"
                },
                "Phetchabun": {
                    "label": "Provincia de Phetchabun",
                    "code": "TH-67"
                },
                "Phetchaburi": {
                    "label": "Provincia de Phetchaburi",
                    "code": "TH-76"
                },
                "Phichit": {
                    "label": "Provincia de Phichit",
                    "code": "TH-66"
                },
                "Phitsanulok": {
                    "label": "Provincia de Phitsanulok",
                    "code": "TH-65"
                },
                "Phra Nakhon Si Ayutthaya": {
                    "label": "Provincia de Phra Nakhon Si Ayutthaya",
                    "code": "TH-14"
                },
                "Phrae": {
                    "label": "Provincia de Phrae",
                    "code": "TH-54"
                },
                "Phuket": {
                    "label": "Provincia de Phuket",
                    "code": "TH-83"
                },
                "Prachin Buri": {
                    "label": "Provincia de Prachinburi",
                    "code": "TH-25"
                },
                "Prachuap Khiri Khan": {
                    "label": "Provincia de Prachuap Khiri Khan",
                    "code": "TH-77"
                },
                "Ranong": {
                    "label": "Provincia de Ranong",
                    "code": "TH-85"
                },
                "Ratchaburi": {
                    "label": "Provincia de Ratchaburi",
                    "code": "TH-70"
                },
                "Roi Et": {
                    "label": "Provincia de Roi Et",
                    "code": "TH-45"
                },
                "Sa Kaeo": {
                    "label": "Provincia de Sa Kaeo",
                    "code": "TH-27"
                },
                "Sakon Nakhon": {
                    "label": "Provincia de Sakon Nakhon",
                    "code": "TH-47"
                },
                "Samut Prakan": {
                    "label": "Provincia de Samut Prakan",
                    "code": "TH-11"
                },
                "Samut Sakhon": {
                    "label": "Provincia de Samut Sakhon",
                    "code": "TH-74"
                },
                "Samut Songkhram": {
                    "label": "Provincia de Samut Songkhram",
                    "code": "TH-75"
                },
                "Saraburi": {
                    "label": "Provincia de Saraburi",
                    "code": "TH-19"
                },
                "Satun": {
                    "label": "Provincia de Satun",
                    "code": "TH-91"
                },
                "Sing Buri": {
                    "label": "Provincia de Sing Buri",
                    "code": "TH-17"
                },
                "Sisaket": {
                    "label": "Provincia de Sisaket",
                    "alternate_names": [
                        "Si Sa Ket"
                    ],
                    "code": "TH-33"
                },
                "Songkhla": {
                    "label": "Provincia de Songkhla",
                    "code": "TH-90"
                },
                "Sukhothai": {
                    "label": "Provincia de Sukhothai",
                    "code": "TH-64"
                },
                "Suphan Buri": {
                    "label": "Provincia de Suphanburi",
                    "code": "TH-72"
                },
                "Surat Thani": {
                    "label": "Provincia de Surat Thani",
                    "code": "TH-84"
                },
                "Tak": {
                    "label": "Provincia de Tak",
                    "code": "TH-63"
                },
                "Trang": {
                    "label": "Provincia de Trang",
                    "code": "TH-92"
                },
                "Ubon Ratchathani": {
                    "label": "Provincia de Ubon Ratchathani",
                    "code": "TH-34"
                },
                "Udon Thani": {
                    "label": "Provincia de Udon Thani",
                    "code": "TH-41"
                },
                "Uthai Thani": {
                    "label": "Provincia de Uthai Thani",
                    "code": "TH-61"
                },
                "Uttaradit": {
                    "label": "Provincia de Uttaradit",
                    "code": "TH-53"
                },
                "Yala": {
                    "label": "Provincia de Yala",
                    "code": "TH-95"
                },
                "Yasothon": {
                    "label": "Provincia de Yasothon",
                    "code": "TH-35"
                },
                "Rayong": {
                    "code": "TH-21"
                },
                "Surin": {
                    "code": "TH-32"
                },
                "Trat": {
                    "code": "TH-23"
                }
            }
        }
    ],
    [
        "Timor Leste",
        {
            "address_format": {
                "edit": 2
            },
            "code": "TL",
            "flag_path": "/assets/flags/tl-8ac967df2d5c61c13c577bd39896de0782249768f01ae00bdf89e67f768c7a3c.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Togo",
        {
            "address_format": {
                "edit": 2
            },
            "code": "TG",
            "flag_path": "/assets/flags/tg-11cb21b053e038b036b27a05db50c717c2f6d0e982e5875f5ff3a7041fe0474d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Tokelau",
        {
            "address_format": {
                "edit": 2
            },
            "code": "TK",
            "flag_path": "/assets/flags/tk-1bd5a4a7a8d2ab41a51d6cd692287d4f5d62ffd680858f3a1afab3c08c56eea3.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Tonga",
        {
            "address_format": {
                "edit": 2
            },
            "code": "TO",
            "flag_path": "/assets/flags/to-a02b5ad2a853655e67adb3a66ac7ec9ebaa7cc32dab7a393dd7d7f0cb64a909b.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Trinidad and Tobago",
        {
            "address_format": {
                "edit": 0
            },
            "code": "TT",
            "flag_path": "/assets/flags/tt-80d3fcf33d02c2f2acf21c5c00dbdd82d8b47744ce50d04440f1481dca44dbcb.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Tristan da Cunha",
        {
            "address_format": {
                "edit": 9
            },
            "code": "TA",
            "flag_path": "/assets/flags/ta-390f7b76dab7f5d1c8693e2fb6eaaa23ea49c51cad8fb40adcf8eafa5704ec3f.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Tunisia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "TN",
            "flag_path": "/assets/flags/tn-585d3ae766ad997f5574205f26ba309f3ffe1191eb0112962af05c4f4debce1e.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Turkey",
        {
            "address_format": {
                "edit": 1
            },
            "code": "TR",
            "flag_path": "/assets/flags/tr-c798c088de6333e4c24db38e14b381120b7e1785a58a47ebdf6696ff93950350.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Turkmenistan",
        {
            "address_format": {
                "edit": 18
            },
            "code": "TM",
            "flag_path": "/assets/flags/tm-1b54bc243dcbe31225740d72d7868ba40fc411983e9e06d5eaa336c4c9fcbaf5.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Turks and Caicos Islands",
        {
            "address_format": {
                "edit": 2
            },
            "code": "TC",
            "flag_path": "/assets/flags/tc-99a025c8197f7f5a7c77fd0e9f70e4c92cee00c394beb93846c7c4c37c23d602.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Tuvalu",
        {
            "address_format": {
                "edit": 2
            },
            "code": "TV",
            "flag_path": "/assets/flags/tv-88d48dc34833e1324defd7ce9d33afd871871dae886abcb11749fdcb0f3d0244.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Uganda",
        {
            "address_format": {
                "edit": 2
            },
            "code": "UG",
            "flag_path": "/assets/flags/ug-b2d885a061dd049c9c1c4065879c5697cf5733054dcff5df54c2c1d759b85acf.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Ukraine",
        {
            "address_format": {
                "edit": 0
            },
            "code": "UA",
            "flag_path": "/assets/flags/ua-eb273df6716db06312dd8a819188b46daf832e6f0afbd69ab866383ae72fc161.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "United Arab Emirates",
        {
            "address_format": {
                "edit": 10
            },
            "code": "AE",
            "flag_path": "/assets/flags/ae-b3dad6d183bae75ccf313057acabddbdb8d59ee550f4231e2f238d3ae28b6d7e.svg",
            "labels": {
                "province": "Emirato"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Abu Dhabi": {
                    "label": "Abu Dabi",
                    "code": "AZ"
                },
                "Ajman": {
                    "label": "Ajmán",
                    "code": "AJ"
                },
                "Dubai": {
                    "label": "Dubái",
                    "code": "DU"
                },
                "Fujairah": {
                    "label": "Fuyaira",
                    "code": "FU"
                },
                "Ras al-Khaimah": {
                    "label": "Ras al-Jaima",
                    "code": "RK"
                },
                "Sharjah": {
                    "code": "SH"
                },
                "Umm al-Quwain": {
                    "label": "Umm al-Qaywayn",
                    "code": "UQ"
                }
            }
        }
    ],
    [
        "United Kingdom",
        {
            "address_format": {
                "edit": 0
            },
            "code": "GB",
            "flag_path": "/assets/flags/gb-7d767b069259074cbce193deb0ff27ad95ac073275e90403b2a15dc0ef3ab991.svg",
            "autocompletion_field": "address1",
            "provinces": {
                "Scotland": {
                    "label": "Escocia",
                    "code": "SCT"
                },
                "British Forces": {
                    "label": "Fuerzas Británicas",
                    "code": "BFP"
                },
                "Wales": {
                    "label": "Gales",
                    "code": "WLS"
                },
                "England": {
                    "label": "Inglaterra",
                    "code": "ENG"
                },
                "Northern Ireland": {
                    "label": "Irlanda del Norte",
                    "code": "NIR"
                }
            }
        }
    ],
    [
        "United States",
        {
            "address_format": {
                "edit": 4
            },
            "code": "US",
            "flag_path": "/assets/flags/us-b2a0509c6ba18185cc6e94d1275d9791bf33e86363defae199078f070e5d7887.svg",
            "labels": {
                "province": "Estado"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Alabama": {
                    "code": "AL"
                },
                "Alaska": {
                    "code": "AK"
                },
                "Arizona": {
                    "code": "AZ"
                },
                "Arkansas": {
                    "code": "AR"
                },
                "California": {
                    "code": "CA"
                },
                "North Carolina": {
                    "label": "Carolina del Norte",
                    "code": "NC"
                },
                "South Carolina": {
                    "label": "Carolina del Sur",
                    "code": "SC"
                },
                "Colorado": {
                    "code": "CO"
                },
                "Connecticut": {
                    "code": "CT"
                },
                "North Dakota": {
                    "label": "Dakota del Norte",
                    "code": "ND"
                },
                "South Dakota": {
                    "label": "Dakota del Sur",
                    "code": "SD"
                },
                "Delaware": {
                    "code": "DE"
                },
                "Florida": {
                    "code": "FL"
                },
                "Georgia": {
                    "code": "GA"
                },
                "Guam": {
                    "code": "GU"
                },
                "Hawaii": {
                    "label": "Hawái",
                    "code": "HI"
                },
                "Idaho": {
                    "code": "ID"
                },
                "Illinois": {
                    "code": "IL"
                },
                "Indiana": {
                    "code": "IN"
                },
                "Iowa": {
                    "code": "IA"
                },
                "Northern Mariana Islands": {
                    "label": "Islas Marianas del Norte",
                    "code": "MP"
                },
                "Marshall Islands": {
                    "label": "Islas Marshall",
                    "code": "MH"
                },
                "Virgin Islands": {
                    "label": "Islas Vírgenes de EE. UU.",
                    "code": "VI"
                },
                "Kansas": {
                    "code": "KS"
                },
                "Kentucky": {
                    "code": "KY"
                },
                "Louisiana": {
                    "label": "Luisiana",
                    "code": "LA"
                },
                "Maine": {
                    "code": "ME"
                },
                "Maryland": {
                    "code": "MD"
                },
                "Massachusetts": {
                    "code": "MA"
                },
                "Michigan": {
                    "label": "Míchigan",
                    "code": "MI"
                },
                "Federated States of Micronesia": {
                    "label": "Micronesia",
                    "code": "FM"
                },
                "Minnesota": {
                    "code": "MN"
                },
                "Mississippi": {
                    "label": "Misisipi",
                    "code": "MS"
                },
                "Missouri": {
                    "label": "Misuri",
                    "code": "MO"
                },
                "Montana": {
                    "code": "MT"
                },
                "Nebraska": {
                    "code": "NE"
                },
                "Nevada": {
                    "code": "NV"
                },
                "New Jersey": {
                    "label": "Nueva Jersey",
                    "code": "NJ"
                },
                "New York": {
                    "label": "Nueva York",
                    "code": "NY"
                },
                "New Hampshire": {
                    "label": "Nuevo Hampshire",
                    "code": "NH"
                },
                "New Mexico": {
                    "label": "Nuevo México",
                    "code": "NM"
                },
                "Ohio": {
                    "code": "OH"
                },
                "Oklahoma": {
                    "code": "OK"
                },
                "Oregon": {
                    "label": "Oregón",
                    "code": "OR"
                },
                "Palau": {
                    "label": "Palaos",
                    "code": "PW"
                },
                "Pennsylvania": {
                    "label": "Pensilvania",
                    "code": "PA"
                },
                "Puerto Rico": {
                    "code": "PR"
                },
                "Rhode Island": {
                    "code": "RI"
                },
                "American Samoa": {
                    "label": "Samoa Americana",
                    "code": "AS"
                },
                "Tennessee": {
                    "code": "TN"
                },
                "Texas": {
                    "code": "TX"
                },
                "Utah": {
                    "code": "UT"
                },
                "Vermont": {
                    "code": "VT"
                },
                "Virginia": {
                    "code": "VA"
                },
                "West Virginia": {
                    "label": "Virginia Occidental",
                    "code": "WV"
                },
                "Washington": {
                    "code": "WA"
                },
                "District of Columbia": {
                    "label": "Washington D. C.",
                    "code": "DC"
                },
                "Wisconsin": {
                    "code": "WI"
                },
                "Wyoming": {
                    "code": "WY"
                },
                "Armed Forces Europe": {
                    "label": "Fuerzas Armadas de Europa",
                    "code": "AE"
                },
                "Armed Forces Americas": {
                    "label": "Fuerzas Armadas de las Américas",
                    "code": "AA"
                },
                "Armed Forces Pacific": {
                    "label": "Fuerzas Armadas del Pacífico",
                    "code": "AP"
                }
            }
        }
    ],
    [
        "United States Minor Outlying Islands",
        {
            "address_format": {
                "edit": 0
            },
            "code": "UM",
            "flag_path": "/assets/flags/um-312ebc51866f7244f06aec6948574d1b725e7b8ed1a219cc2ca7a20713c41898.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Uruguay",
        {
            "address_format": {
                "edit": 3
            },
            "code": "UY",
            "flag_path": "/assets/flags/uy-ea9c56355f22f711dd1f1c39725dc145d4343f03f79927860dc425e6ad54fd6d.svg",
            "labels": {
                "province": "Departamento",
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Artigas": {
                    "label": "Departamento de Artigas",
                    "code": "UY-AR"
                },
                "Canelones": {
                    "label": "Departamento de Canelones",
                    "code": "UY-CA"
                },
                "Cerro Largo": {
                    "label": "Departamento de Cerro Largo",
                    "code": "UY-CL"
                },
                "Colonia": {
                    "label": "Departamento de Colonia",
                    "code": "UY-CO"
                },
                "Durazno": {
                    "label": "Departamento de Durazno",
                    "code": "UY-DU"
                },
                "Flores": {
                    "label": "Departamento de Flores",
                    "code": "UY-FS"
                },
                "Florida": {
                    "label": "Departamento de Florida",
                    "code": "UY-FD"
                },
                "Lavalleja": {
                    "label": "Departamento de Lavalleja",
                    "code": "UY-LA"
                },
                "Maldonado": {
                    "label": "Departamento de Maldonado",
                    "code": "UY-MA"
                },
                "Montevideo": {
                    "label": "Departamento de Montevideo",
                    "code": "UY-MO"
                },
                "Paysandú": {
                    "label": "Departamento de Paysandú",
                    "alternate_names": [
                        "Paysandu"
                    ],
                    "code": "UY-PA"
                },
                "Río Negro": {
                    "label": "Departamento de Río Negro",
                    "alternate_names": [
                        "Rio Negro"
                    ],
                    "code": "UY-RN"
                },
                "Rivera": {
                    "label": "Departamento de Rivera",
                    "code": "UY-RV"
                },
                "Rocha": {
                    "label": "Departamento de Rocha",
                    "code": "UY-RO"
                },
                "Salto": {
                    "label": "Departamento de Salto",
                    "code": "UY-SA"
                },
                "San José": {
                    "label": "Departamento de San José",
                    "alternate_names": [
                        "San Jose"
                    ],
                    "code": "UY-SJ"
                },
                "Soriano": {
                    "label": "Departamento de Soriano",
                    "code": "UY-SO"
                },
                "Tacuarembó": {
                    "label": "Departamento de Tacuarembó",
                    "alternate_names": [
                        "Tacuarembo"
                    ],
                    "code": "UY-TA"
                },
                "Treinta y Tres": {
                    "label": "Departamento de Treinta y Tres",
                    "code": "UY-TT"
                }
            }
        }
    ],
    [
        "Uzbekistan",
        {
            "address_format": {
                "edit": 0
            },
            "code": "UZ",
            "flag_path": "/assets/flags/uz-705caaf4443808659ac4d6c5eb7b428f27d30aaabd4205e1158ebf4dcefce723.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Vanuatu",
        {
            "address_format": {
                "edit": 2
            },
            "code": "VU",
            "flag_path": "/assets/flags/vu-817f38a6c5713ffc99cc2ebd7d3740da96cf346924ce90bd38e454b800c57de6.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Venezuela",
        {
            "address_format": {
                "edit": 8
            },
            "code": "VE",
            "flag_path": "/assets/flags/ve-f48ca6b787d3f7487f285d7cf78030f5295d41bcd00d3f52ad5246c2c6946223.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1",
            "provinces": {
                "Amazonas": {
                    "code": "VE-Z"
                },
                "Anzoátegui": {
                    "alternate_names": [
                        "Anzoategui"
                    ],
                    "code": "VE-B"
                },
                "Apure": {
                    "code": "VE-C"
                },
                "Aragua": {
                    "code": "VE-D"
                },
                "Barinas": {
                    "code": "VE-E"
                },
                "Bolívar": {
                    "alternate_names": [
                        "Bolivar"
                    ],
                    "code": "VE-F"
                },
                "Carabobo": {
                    "code": "VE-G"
                },
                "Cojedes": {
                    "code": "VE-H"
                },
                "Delta Amacuro": {
                    "code": "VE-Y"
                },
                "Dependencias Federales": {
                    "label": "Dependencias Federales Venezolanas",
                    "code": "VE-W"
                },
                "Distrito Capital": {
                    "code": "VE-A"
                },
                "Falcón": {
                    "alternate_names": [
                        "Falcon"
                    ],
                    "code": "VE-I"
                },
                "Guárico": {
                    "alternate_names": [
                        "Guarico"
                    ],
                    "code": "VE-J"
                },
                "Lara": {
                    "code": "VE-K"
                },
                "Mérida": {
                    "alternate_names": [
                        "Merida"
                    ],
                    "code": "VE-L"
                },
                "Miranda": {
                    "code": "VE-M"
                },
                "Monagas": {
                    "code": "VE-N"
                },
                "Nueva Esparta": {
                    "code": "VE-O"
                },
                "Portuguesa": {
                    "code": "VE-P"
                },
                "Sucre": {
                    "code": "VE-R"
                },
                "Táchira": {
                    "alternate_names": [
                        "Tachira"
                    ],
                    "code": "VE-S"
                },
                "Trujillo": {
                    "code": "VE-T"
                },
                "La Guaira": {
                    "label": "Vargas",
                    "code": "VE-X"
                },
                "Yaracuy": {
                    "code": "VE-U"
                },
                "Zulia": {
                    "code": "VE-V"
                }
            }
        }
    ],
    [
        "Vietnam",
        {
            "address_format": {
                "edit": 0
            },
            "code": "VN",
            "flag_path": "/assets/flags/vn-514f59f8d1efdbff4112457a15f7b01188b9f9a3ba46f09d24ba2484022025f2.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Virgin Islands, British",
        {
            "address_format": {
                "edit": 0
            },
            "code": "VG",
            "flag_path": "/assets/flags/vg-e35f61de0e7870ac921bd658893df0ca1cc4f2cf67a088fc5e6295e5ef69dce4.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Wallis And Futuna",
        {
            "address_format": {
                "edit": 1
            },
            "code": "WF",
            "flag_path": "/assets/flags/wf-69b4632ef097453bb836b92201737892bb6640fb64c18381245e6f1b0e1df3cf.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Western Sahara",
        {
            "address_format": {
                "edit": 0
            },
            "code": "EH",
            "flag_path": "/assets/flags/eh-6c7e2ee019d8a71f99790472afc2372cbf172096f9f468f19c2a6a9c6c9bca27.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Yemen",
        {
            "address_format": {
                "edit": 2
            },
            "code": "YE",
            "flag_path": "/assets/flags/ye-a92f3989182049dc218f7698c45d8cdfc64e6f945c71f20a9d188dd01698df2d.svg",
            "autocompletion_field": "address1"
        }
    ],
    [
        "Zambia",
        {
            "address_format": {
                "edit": 1
            },
            "code": "ZM",
            "flag_path": "/assets/flags/zm-12b304c730ba55405d972d66f0bf839cf0a73089ddcef69c46819b1a867a7e5b.svg",
            "labels": {
                "zip": "Código postal (opcional)"
            },
            "autocompletion_field": "address1"
        }
    ],
    [
        "Zimbabwe",
        {
            "address_format": {
                "edit": 2
            },
            "code": "ZW",
            "flag_path": "/assets/flags/zw-65e45fb137d7c8e7cf9d30a221c8447b6a896c7f36b90d43dc847580ffa47545.svg",
            "autocompletion_field": "address1"
        }
    ]
]
const token = 'ZDY1YWQ3MGUyNzNlMThjNGQ2NzlmNWRjYjdhMmEwODY6c2hwcGFfYTFjY2U4NzZkZmQwOTgzOWNlOTdlNmU5ZWE1MjAzNTY='
const btnCoupon = $('#btn-coupon') 
const errorCoupon = $('.error-coupon')
const coupon = $('#coupon')
const discount = []
// const value_discoun = $('#value-discoun')
const txt_discount = $('#txt-discount') 
const table_coupon = $('.table-coupon')
let exist = false
let couponApplied = false
let authorizationAmount = total_cart 
let valueDiscount = 0
let displayProvinceText = true
let usage_count = 0
const dataNow = new Date();
let authorizationAmount2


$(document).ready(() => {
  console.log("Inicia PayU")
  setCountries()
})

btnModalPayu.click(() => {
    $('.payu-modal').css('display', 'flex') 
})

closeModalPayu.click(() => {
  $('.payu-modal').css('display', 'none') 
}) 

btnContinue.click( () => {
    validate_fields()
    getAuthorizationAmount()
})

btnCoupon.click (() => {
  
  if (coupon == "" || coupon == null) {
    errorCoupon.text('Ingrese un cupón válido')
    errorCoupon.show()
    return
  }
  loadBtnCoupon(true)
  validateCoupon()
})

function loadBtn(load) {
    if (load) {
        btnContinue[0].classList.add("loading")
        btnContinue.val(btnContinue.attr('data-loading'))
        btnContinue.prop('disabled', true);

    }else{
        btnContinue[0].classList.remove("loading")
        btnContinue.val(btnContinue.attr('data-value'))
        btnContinue.prop('disabled', false);
    }
}

function loadBtnCoupon(load) {
  if (load) {
    btnCoupon[0].classList.add("loading")
    btnCoupon.val(btnCoupon.attr('data-loading'))
    btnCoupon.prop('disabled', true);

  }else{
    btnCoupon[0].classList.remove("loading")
    btnCoupon.val(btnCoupon.attr('data-value'))
    btnCoupon.prop('disabled', false);
  }
}

validate_fields = async () => {
  let fullName =  $('#buyerFullName').val() 
  let email = $('#buyerEmail').val()
  let shippingAddress = $('#address1').val()
  let shippingCountry = $('#city').val()
  let phone = $('#phone').val()
  let province_text = $('#province_text').val()
  var regName =  /^[a-zA-Z]+( [a-zA-Z]+)+$/
  var regEmail = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i

  if (!regName.test(fullName)) {
    $('.label-fullname').css('display', 'flex');
    return false;
  } else {
    $('.label-fullname').css('display','none')  
  }

  if (!regEmail.test(email)) {
    $('.label-email').css('display','flex')  
    return false
  } else {
    $('.label-email').css('display','none')
  }

  if (shippingAddress == null  || shippingAddress == '') {
    $('.label-shippingAddress').css('display','flex')
    return false
  } else {
    $('.label-shippingAddress').css('display','none')
  }

  if (shippingCountry == null  || shippingCountry == '') {
    $('.label-shippingCountry').css('display','flex')
    return false
  } else {
    $('.label-shippingCountry').css('display','none')
  }

  if (phone == null  || phone == '') {
    $('.label-phone').css('display','flex')
    return false
  } else {
    $('.label-phone').css('display','none')
  }
  
  if (displayProvinceText) {
    if (province_text == null  || province_text == '') {
      $('.label-province_text').css('display','flex')
      return false 
    } else {
      $('.label-province_text').css('display','none')
    }
  }
    


  $('.invalidfield').css('display','none')
  createOrder()


}
const validateCoupon = async () => {
  errorCoupon.hide()
  table_coupon.hide()
  try {
    const rawData = await fetch(`https://proxy-cors-v-1-dot-saving-the-amazon-155216.ue.r.appspot.com/https://saving-the-amazon.myshopify.com/admin/api/2022-01/discount_codes/lookup.json?code=${coupon.val()}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${token}`  
          }
    })
    const data = await rawData.json()
    if (data.discount_code.price_rule_id != null) {
      usage_count = data.discount_code.usage_count
      getPriceRules(data.discount_code.price_rule_id)
    }else{
      errorCoupon.text('Ingrese un cupón válido')
      errorCoupon.show()
      loadBtnCoupon(false)
    }

  } catch (error) {
    errorCoupon.text('Error al validar el cupón')
    errorCoupon.show()
    loadBtnCoupon(false)
  }
}


const getPriceRules = async (id_rules = null) => {
  try {
    const rawData = await fetch(`https://proxy-cors-v-1-dot-saving-the-amazon-155216.ue.r.appspot.com/https://saving-the-amazon.myshopify.com//admin/api/2022-01/price_rules/${id_rules}.json`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${token}`  
          },
    })
    const data = await rawData.json()
    if (data.price_rule.id != null) {
      if (usage_count >= data.price_rule.usage_limit && data.price_rule.usage_limit != null) {
        errorCoupon.text('El cupón ya fue redimido')
        errorCoupon.show()
        loadBtnCoupon(false)
        return
      }
     
      // console.log(`${dataNow} > = ${data.price_rule.ends_at} ---- ${ends_at}`);
      if (data.price_rule.ends_at != null ) {
        ends_at = new Date(data.price_rule.ends_at)
        if (dataNow.toLocaleString() >= ends_at.toLocaleString()) {
          errorCoupon.text('El cupón ya caduco')
          errorCoupon.show()
          loadBtnCoupon(false)
          return
        }
      }
        
      if (discount.length > 0) {
        existsArrayCoupon(discount, data.price_rule.title) 
        if(!exist)
        {
          console.log('entra no existe');
          discount.push({
            "code":data.price_rule.title,
            "amount":Math.abs(data.price_rule.value),
            "type":data.price_rule.value_type
          })
          // authorizationAmount = authorizationAmount - Math.abs(data.price_rule.value)
        }
      } else {
        console.log('primero no existe');
        discount.push({
          "code":data.price_rule.title,
          "amount":Math.abs(data.price_rule.value),
          "type":data.price_rule.value_type
        })
        // authorizationAmount = authorizationAmount - Math.abs(data.price_rule.value)
      }
      InsertTableCoupon()
      couponApplied = true
      table_coupon.show()
      loadBtnCoupon(false)
    }else{
      errorCoupon.text('Error al validar el valor del cupón')
      errorCoupon.show()
      loadBtnCoupon(false)
    }
  } catch (error) {
    errorCoupon.text('Error al validar el valor del cupón' + error)
    errorCoupon.show()
    loadBtnCoupon(false)
  }
}

function getAuthorizationAmount() {
  //  var subtotal = total_cart
  //  if (currencyIsoCode == 'COP') {
  //   formatCurrency = new Intl.NumberFormat("es-CO", {
  //     currency: "COP",
  //     minimumFractionDigits: 0
  //   }).format(subtotal);
  //   subtotalUSD = formatCurrency / 3.500
  //  }
    
  //  if (currencyIsoCode == 'BRL') {
  //   subtotalUSD = new Intl.NumberFormat("pt-BR", {
  //     currency: "BRL",
  //     minimumFractionDigits: 0
  //   }).format(subtotal);
  //   subtotalUSD = formatCurrency / 6
  //  }

  //  if (currencyIsoCode == 'USD') { 
  //   subtotalUSD = subtotal
  //  }
if (total_cart.startsWith("R")) {
  total_cart = total_cart.replace(/\./g, ""); // quitar puntos de miles
  total_cart = total_cart.replace(",", ".");  // reemplazar coma por punto decimal
  total_cart = parseFloat(total_cart.substring(1)); // eliminar la R y convertir a float
}
authorizationAmount = total_cart; 
  authorizationAmount = authorizationAmount.toString().replace(/\./g, '');
    //float
    authorizationAmount = parseFloat(authorizationAmount.toString().replace(/\./g, '').replace(',', '.')).toFixed(2);

  //string
    // authorizationAmount = authorizationAmount.toString().replace(/\./g, '');

  //entero
  // authorizationAmount = parseInt(authorizationAmount).toString();
}

const createOrder = async () => {
    loadBtn(true)
    var fullName = $('#buyerFullName').val()
    var firstName = fullName.split(' ').slice(0, -1).join(' ');
    var lastName = fullName.split(' ').slice(-1).join(' ');
    console.log("Dentro de createOrder")
    console.log(authorizationAmount)

    if (authorizationAmount.startsWith("R")) {
      authorizationAmount = parseFloat(authorizationAmount.substring(2, authorizationAmount.length));
      console.log("Dentro de createOrder después de convertir")
      console.log(authorizationAmount)
    }
  
    var order = {
        "order" :{
            "email":$('#buyerEmail').val(),
            "fulfillment_status":null,
            "send_receipt":false,
            "send_fulfillment_receipt":false,
            "financial_status":"pending",
            "customer":{
                "first_name":firstName,
                "last_name":lastName,
                "email":$('#buyerEmail').val()
            },
            "shipping_address":{
              "first_name":firstName,
              "last_name":lastName,
              "address1":$('#address1').val(),
              "address2":$('#address2').val(),
              "phone":$('#phone').val(),
              "city":$('#city').val(),
              "province":province.val(),
              "country":$(':selected', billingCountry).data('name'),
        
            },
              "transactions":[
                {
                  "kind":"authorization",
                  "status":"success",
                  "amount": parseFloat(authorizationAmount),
                  "currency": currencyIsoCode
                }
            ],
            "discount_codes": discount,
            "line_items": []
        }
    }
  console.log(order)
  
    var line_items_array = []
    $.each( sa_cart.items, function( i, item ) {
        item.properties.referenceCodePayu = `#payu_${referenceCode}`
        line_items_array.push({
            "variant_id" : item.variant_id,
            "quantity" : item.quantity,
            "properties" : item.properties,
            "taxes" : (item.final_line_price / 100) * 0.19, 
            "originalPrice" : item.final_line_price
        })
      
      });
      order.order.line_items =  line_items_array
       
      try {
        const rawData = await fetch(`https://proxy-cors-v-1-dot-saving-the-amazon-155216.ue.r.appspot.com/https://saving-the-amazon.myshopify.com/admin/api/2022-04/orders.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${token}`  
          },
          body: JSON.stringify(order)
        })
        const data = await rawData.json()
        console.log("esta es la data ")
        console.log(JSON.stringify(data))
        if (data.order.id) {
            $('#idOrder').val(data.order.id)
            if(couponApplied) {

              total_cart = data.order.total_price
              if (currencyIsoCode == 'COP') {
                total_cart = (data.order.total_price * 4400)
              }

              if(currencyIsoCode == 'BRL') {
                total_cart = (data.order.total_price * 6)
              }
              // generateSignature()
            }

            console.log("Antes de total")
            console.log(total_cart)
            var total
            if (currencyIsoCode == "COP") {
                total = parseInt(String(total_cart).replace(/\./g, ''), 10);
                console.log(total);
            } else if (currencyIsoCode == "BRL") {
              console.log(total_cart)
              total = total_cart
              console.log("dentro de total")
              console.log(total)
            } else {
              // total = total_cart.toString().replace(".","")
              total = total_cart.toString()
              console.log("Total cart USD")
              console.log(total)
            }
            total_cart = total
            const itemEncontrado = data.order.line_items.some(item => item.variant_id == "50784634044754");

            if (itemEncontrado) {
              total = total + (total * 0.19)
              total_cart = total
            }
            $('#amount').val(total)
            generateSignature()
            sendPayu()
        } else {
              
            loadBtn(false)
            alert('a ocurrido un error al crear la orden intenta nuevamente')
        }

        console.log(data)
      } catch (error) {
        loadBtn(false) 
        alert(`Ha ocurrido un error ${error}`)
      }

    console.log(line_items_array);  
    console.log(order);
    console.log(sa_cart);
}

const sendPayu = async () => {
    $('#referenceCode').val(`#payu_${referenceCode}`)
    $('#signature').val(signature)
    btnSubmitForm.trigger("click")
}

const setCountries = () => {
  console.log("Inicia Payu")
   if(countriesOrdered.length > 0)  {
      i = 0
      countriesOrdered.forEach(([key, countrie]) => {
        billingCountry.prepend(`<option value="${countrie.code}" data-name="${countrie.code}" data-index="${i}" >${key}</option>`)
        i++
      });
   }
}

billingCountry.change(function() {
  index = $(':selected', $(this)).data('index')
  _countries = countriesOrdered
  if (_countries[index][1].provinces != null) {
    province_text.hide()
    province.show()
    displayProvinceText = false
    provinces = _countries[index][1].provinces
    $.each( provinces, function( key, value ) {
      province.prepend(`<option value="${key}" >${key}</option>`)
    })
  }else{
    province_text.show()
    province.hide()
    displayProvinceText = true 
  }

  if (_countries[index][1].labels.province != null ) {
    province.attr("placeholder", _countries[index][1].labels.province)
    province_text.attr("placeholder", _countries[index][1].labels.province)
  }
  console.log(_countries);
});

function existsArrayCoupon(object, search ) {
  exist = false
  $.each(object, function (key, value) {
    if (value.code == search) {
      exist = true
      return false
    }
  })
}

function InsertTableCoupon() {
  $(".table-coupon>tbody").html('')
  $.each(discount, function (key, value) {
    $(".table-coupon>tbody").prepend(`<tr><td>${value.code}</td><td> - ${value.amount}</td></tr>`);
  })
}

function generateSignature(){
  console.log('llamada');
  console.log(`t0ilh9ku7soq1eq2mh2v2bhlr~510482~#payu_${referenceCode}~${total_cart}~${currencyIsoCode}`)
  signature = CryptoJS.MD5(`t0ilh9ku7soq1eq2mh2v2bhlr~510482~#payu_${referenceCode}~${total_cart}~${currencyIsoCode}`).toString()
  console.log(signature)
}




